import React, { useEffect, useState } from 'react';
import './dcrt.scss';
import { ArrowBack, ArrowForward, CleaningServices, NoteAltTwoTone, Search } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import Fab from '@mui/material/Fab';
import { Switch } from "@mui/material";
import { FUllPill } from '../Pill/Pill';
import { useNavigate, useLocation } from 'react-router-dom';
//import { Doc, Person, File, Edit, Document, Check, Documentos, Documentosred, GreenCheck } from '../../../assets/icons/component';
import { Doc, Person, File, Document, RedCheck, Edit, Check, GreenCheck, GreenCheckBig, Documentos, Documentosred, Redx } from '../../../assets/icons/component';
import { Rating } from '../RatingScore';
import { typeIdentification, estractos, cities, Ocupaciones, Parentescos } from '../../../__mocks__/data';
import { AppRoutes } from "../../../Router";
import { WLOCreditAPIService, AdminService } from '../../../services';
import { WloCreditoService } from '../../../types';
import toast from 'react-hot-toast';
import { Field, Form, Formik } from "formik";
import Moment from 'moment';
import { useIntl } from "react-intl";
import { useLoginContext } from "../../../hooks/useLoginContext";
import ParseNumberThousand from "../../shared/Utilities/ParseNumberThousand";
import _ from "lodash";
import { useRequestContext } from '../../../hooks/useRequestContext';
import ClockLoader from "react-spinners/ClockLoader";
import { FormSpouseCodeudor } from '../../Steps/ApplicantInfo/ModalSpouse/FormSpouseCodeudor';
import { ModalReferencesCodeudor } from '../../Steps/DocumentsInformation/ModalReferences/ModalReferenceCodeudores';
import NumberFormat from 'react-number-format';

////
// interface DataDesem {
//     score: number;
//     DataCredito: boolean;
//     listaRestrictiva: boolean;
//     sagrilaft: boolean;
//     estado: string;
//     color: string;
// }

// const dataDesem: DataDesem = {
//     score: 0,
//     DataCredito: false,
//     listaRestrictiva: false,
//     sagrilaft: false,
//     estado: '',
//     color: ''
// };
/////
const data = [
    {
        bg1: '#D0021B',
        text: 'Información del crédito',
        bg2: 'none',
        abcilon: '',
        revisado: true,
    },
    {
        bg1: '#4A4A4A',
        text: 'Información personal',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Información financiera',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Documentos de la solicitud',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Referencias',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Información codeudor Propetario',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Información codeudor Requerido',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Información de verificación',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Calificar la Solicitud',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Documentos de Garantia',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
];

const dataGestor = [
    {
        bg1: '#D0021B',
        text: 'Información del crédito',
        bg2: 'none',
        abcilon: '',
        revisado: true,
    },
    {
        bg1: '#4A4A4A',
        text: 'Información personal',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Información financiera',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Documentos de la solicitud',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Referencias',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Información codeudor Propetario',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Información codeudor Requerido',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Información de verificación',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Consulta a terceros',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Calificar la Solicitud',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
    {
        bg1: '#4A4A4A',
        text: 'Documentos de Garantia',
        bg2: '#F13A00',
        abcilon: '!',
        revisado: false,
    },
];

export const Box2 = (valorPersonal?: any) => {
    const { person } = valorPersonal.valorPersonal;
    const { dataConyuge } = valorPersonal.valorPersonal;
    const { request, setRequest } = useRequestContext();
    const [persona, DatoPersona] = React.useState({} as any);
    const [update, setUpdate] = React.useState(false);
    const [NoReadCedula, setReadCedula] = React.useState(true);
    const intl = useIntl();
    const [one] = React.useState(false)
    const [ciudades, setCiudades] = React.useState(cities as any);
    const [ciudades2, setCiudades2] = React.useState(cities as any);
    const [departamentos, setDepartamentos] = React.useState(cities as any)
    const [allCities, setAllCiudades] = React.useState(cities as any);
    const [EstadosCivil, setEstadosCivil] = useState([] as any);
    const [tipovivi, setTipoVivienda] = useState([]);
    const [NivelEsti, setNivelEstudio] = useState([]);
    const [TipoContrato, setAllTipoContrato] = useState([] as any);
    const [allOcupaciones, SetAllOcupaciones] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event: any) => {
        setSelectedOption(event.target.value)
        valorPersonal.valorPersonal.person.Pws_Estado_Civil = event.target.value
        if (event.target.value === "1" || event.target.value === "3") {
            setModal(!modal);
        }
    };

    useEffect(() => {
        AdminService.getAllCiudades().then((Datos: any) => {
            if (parseInt(Datos.payload.data.ListCiudad.Datos_Ciudad[0].s_codigo) > 0) {
                setAllCiudades(Datos.payload.data)
            }
        })
        getAlldata()
    }, [one])
    const toggle = () => setModal(!modal);
    const getAlldata = async () => {

        const estadosCvil = await AdminService.getEstadosCiviles();
        if (estadosCvil.payload.data.listEstCivil.Datos_EstCivil.length > 0 &&
            estadosCvil.payload.data.listEstCivil.Datos_EstCivil[0].s_codigo > 0) {
            setEstadosCivil(estadosCvil.payload.data.listEstCivil.Datos_EstCivil)
        } else {
            let estadocivil = [
                { s_codigo: "1", s_descripcion: "CASADO" },
                { s_codigo: "2", s_descripcion: "SOLTERO" },
                { s_codigo: "3", s_descripcion: "UNION LIBRE" },
                { s_codigo: "4", s_descripcion: "VIUDO" },
                { s_codigo: "5", s_descripcion: "SEPARADO" }
            ]
            setEstadosCivil(estadocivil)
        }
        const tipovivienda = await AdminService.gettipovivienda();
        if (tipovivienda.payload.data.tip_viv.datos_tip_vivi.length > 0) {
            setTipoVivienda(tipovivienda.payload.data.tip_viv.datos_tip_vivi)
        }
        const nivelEstudi = await AdminService.getNivelEstudio();
        if (nivelEstudi.payload.data.listTipoNivEstudio.Datos_TiposNivelEstudio.length > 0) {
            setNivelEstudio(nivelEstudi.payload.data.listTipoNivEstudio.Datos_TiposNivelEstudio)
        }
        const tipocon = await AdminService.getTipoContrato();
        if (tipocon.payload.data.listTipoContr.Datos_TipoContrato.length > 0 &&
            parseInt(tipocon.payload.data.listTipoContr.Datos_TipoContrato[0].s_codigo) > 0) {
            setAllTipoContrato(tipocon.payload.data.listTipoContr.Datos_TipoContrato)
        } else {
            let tipContrato = [
                { s_codigo: "1", s_descripcion: "INDEFINIDO" },
                { s_codigo: "2", s_descripcion: "TERMINO FIJO" },
                { s_codigo: "3", s_descripcion: "N/A" },
                { s_codigo: "4", s_descripcion: "OBRA O LABOR" },
                { s_codigo: "5", s_descripcion: "TEMPORAL" }
            ]
            setAllTipoContrato(tipContrato)
        }

       const ocupaciones = await AdminService.getOcupaciones();
        if (ocupaciones.payload.data.ListOcup.Datos_Ocupaciones.length > 0) {
            SetAllOcupaciones(ocupaciones.payload.data.ListOcup.Datos_Ocupaciones)
        }
    }
    useEffect(() => {
        if (request.direcciones) {
            valorPersonal.valorPersonal.person.Pws_Direccion_res = request.direcciones.road + " " + request.direcciones.mainno + " " + request.direcciones.suffix + " " + request.direcciones.secondaryno + " " + request.direcciones.suffix2 + " " + request.direcciones.complementaryno + " " + request.direcciones.Complement + " " + request.direcciones.complementaryno2 + " " + request.direcciones.Complement3 + " " + request.direcciones.complementaryno3 + " " + request.direcciones.Neighborhood
            valorPersonal.valorPersonal.person.Pws_Direccion_res = request.direcciones.road + " " + request.direcciones.mainno + " " + request.direcciones.suffix + " " + request.direcciones.secondaryno + " " + request.direcciones.suffix2 + " " + request.direcciones.complementaryno + " " + request.direcciones.Complement + " " + request.direcciones.complementaryno2 + " " + request.direcciones.Complement3 + " " + request.direcciones.complementaryno3 + " " + request.direcciones.Neighborhood
            }
            if (request.dataModifcable) {
                if (request.dataModifcable.idUser) {
                    setReadCedula(false)
                }
            }

        }, [request, setRequest])
        const handleSearch = async () => {
            setIsLoading(true);
            if (!_.isEmpty(valorPersonal.valorPersonal.person.Pws_Tip_Identificacion!) || !_.isEmpty(valorPersonal.valorPersonal.person.Pws_Identificacion!)) {
                if (valorPersonal.valorPersonal.person.Pws_Identificacion.length < 5) {
                    toast.error('Debe indicar un Número de Identificación entre 5 y 10 caracteres');
                } else {
                    try {
                        const person2 = await WLOCreditAPIService.consultaSolicitudCygnus({
                            Pws_Tip_Identificacion: valorPersonal.valorPersonal.person.Pws_Tip_Identificacion!,
                            Pws_Identificacion: valorPersonal.valorPersonal.person.Pws_Identificacion!
                        });
                        if (!_.isEmpty(person2.payload)) {
                            if (person2.payload.result === "1") {
                                person.Pws_Apellidos1 = person2.payload.data.datos_persona.Datos_persona[0].Pws_Apellidos1
                                person.Pws_Apellidos2 = person2.payload.data.datos_persona.Datos_persona[0].Pws_Apellidos2
                                person.Pws_Tip_person = person2.payload.data.datos_persona.Datos_persona[0].Pws_Tip_person
                                person.Pws_Nombres = person2.payload.data.datos_persona.Datos_persona[0].Pws_Nombres
                                person.Pws_Tip_Perfil = person2.payload.data.datos_persona.Datos_persona[0].Pws_Tip_Perfil
                                person.Pws_Telefono1 = person2.payload.data.datos_persona.Datos_persona[0].Pws_Telefono1
                                person.Pws_Telefono2 = person2.payload.data.datos_persona.Datos_persona[0].Pws_Telefono2
                                person.Pws_Correo = person2.payload.data.datos_persona.Datos_persona[0].Pws_Correo
                                person.Pws_Tip_ocupa = person2.payload.data.datos_persona.Datos_persona[0].Pws_Tip_ocupa
                                person.Pws_Fec_expe = person2.payload.data.datos_persona.Datos_persona[0].Pws_Fec_expe.split("-00")[0]
                                person.Pws_Lugar_exp = person2.payload.data.datos_persona.Datos_persona[0].Pws_Lugar_exp == 0 ? "" : person2.payload.data.datos_persona.Datos_persona[0].Pws_Lugar_exp
                                person.Pws_Fec_nacime = person2.payload.data.datos_persona.Datos_persona[0].Pws_Fec_nacime.split("-00")[0]
                                person.Pws_Estado_Civil = person2.payload.data.datos_persona.Datos_persona[0].Pws_Estado_Civil
                                person.Pws_Direccion_res = person2.payload.data.datos_persona.Datos_persona[0].Pws_Direccion_res
                                person.Pws_Departamento = person2.payload.data.datos_persona.Datos_persona[0].Pws_Departamento
                                person.Pws_Ciudad_res = person2.payload.data.datos_persona.Datos_persona[0].Pws_Ciudad_res
                                person.Pws_Genero = person2.payload.data.datos_persona.Datos_persona[0].Pws_Genero
                                person.Pws_Estrato_per = person2.payload.data.datos_persona.Datos_persona[0].Pws_Estrato_per
                                person.Pws_Per_cargo = person2.payload.data.datos_persona.Datos_persona[0].Pws_Per_cargo
                                person.Pws_Tip_vivienda = person2.payload.data.datos_persona.Datos_persona[0].Pws_Tip_vivienda
                                person.Pws_Niv_estudio = person2.payload.data.datos_persona.Datos_persona[0].Pws_Niv_estudio
                                person.Pws_Nom_empre = person2.payload.data.datos_persona.Datos_persona[0].Pws_Nom_empre
                                person.Pws_fec_ingemp = person2.payload.data.datos_persona.Datos_persona[0].Pws_fec_ingemp.split("-00")[0]
                                person.Pws_Fideliza = person2.payload.data.datos_persona.Datos_persona[0].Pws_Fideliza
                                person.Pws_Tip_contra = person2.payload.data.datos_persona.Datos_persona[0].Pws_Tip_contra
                                person.Pws_Ant_labo = person2.payload.data.datos_persona.Datos_persona[0].Pws_Ant_labo
                                person.Pws_Car_emp = person2.payload.data.datos_persona.Datos_persona[0].Pws_Car_emp
                                person.Pws_Nom_Jefedi = person2.payload.data.datos_persona.Datos_persona[0].Pws_Nom_Jefedi
                                person.Pws_Direc_emp = person2.payload.data.datos_persona.Datos_persona[0].Pws_Direc_emp
                                person.Pws_Ciud_emp = person2.payload.data.datos_persona.Datos_persona[0].Pws_Ciud_emp
                                person.Pws_tel_emp1 = person2.payload.data.datos_persona.Datos_persona[0].Pws_tel_emp1
                                person.Pws_tel_emp2 = person2.payload.data.datos_persona.Datos_persona[0].Pws_tel_emp2
                                setReadCedula(true)
                            } else {
                                const personANI = await WLOCreditAPIService.consultaSolicitudANI({
                                    Pws_Tip_Identificacion: valorPersonal.valorPersonal.person.Pws_Tip_Identificacion!,
                                    Pws_Identificacion: valorPersonal.valorPersonal.person.Pws_Identificacion!
                                });
                                const fecha = personANI.fechaExpedicion.split('/');
                                person.Pws_Apellidos1 = personANI.primerApellido
                                person.Pws_Apellidos2 = personANI.segundoApellido
                                person.Pws_Tip_person = "N"
                                person.Pws_Nombres = personANI.primerNombre + " " + personANI.segundoNombre
                                person.Pws_Telefono1 = ""
                                person.Pws_Telefono2 = ""
                                person.Pws_Correo = ""
                                person.Pws_Tip_ocupa = ""
                                person.Pws_Fec_expe = fecha[2] + '-' + fecha[1] + '-' + fecha[0]
                                person.Pws_Lugar_exp= _.filter( allCities.ListCiudad.Datos_Ciudad, 
                                    { s_nivel: '3',s_nombre: personANI.municipioExpedicion}).length>0?
                                    _.filter( allCities.ListCiudad.Datos_Ciudad, 
                                    {s_nivel: '3', s_nombre: personANI.municipioExpedicion})[0].s_codigo:""
                                person.Pws_Fec_nacime = ""
                                person.Pws_Estado_Civil = ""
                                person.Pws_Direccion_res = ""
                                person.Pws_Departamento = ""
                                person.Pws_Ciudad_res = ""
                                person.Pws_Genero = ""
                                person.Pws_Estrato_per = ""
                                person.Pws_Per_cargo = ""
                                person.Pws_Tip_vivienda = ""
                                person.Pws_Niv_estudio = ""
                                person.Pws_Nom_empre = ""
                                person.Pws_fec_ingemp = ""
                                person.Pws_Fideliza = ""
                                person.Pws_Tip_contra = ""
                                person.Pws_Ant_labo = ""
                                person.Pws_Car_emp = ""
                                person.Pws_Nom_Jefedi = ""
                                person.Pws_Direc_emp = ""
                                person.Pws_Ciud_emp = ""
                                person.Pws_tel_emp1 = ""
                                person.Pws_tel_emp2 = ""
                                setReadCedula(true)
                            }
                        }
                    } catch (e) {
                        const error = e as any;
                        console.log(error)
                        setReadCedula(false)
                        toast("ANI Fuera de servicio te recomendamos llenar los datos manuelamente ")
                    }
                }
            }
            setIsLoading(false);
        }
        useEffect(() => {
            if (allCities) {

                let citiesDepent = {
                    "ListCiudad": {
                        "Datos_Ciudad": [] as any
                    }
                }
            citiesDepent.ListCiudad.Datos_Ciudad = _.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '2' });
            setDepartamentos(citiesDepent)
        }
    }, [allCities])

    const handleCities = (e: { target: { value: string; }; }) => {
        let citiesDepent = {
            "ListCiudad": {
                "Datos_Ciudad": [] as any
            }
        }
        citiesDepent.ListCiudad.Datos_Ciudad = _.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3', s_ubicacion: e.target.value });
        setCiudades(citiesDepent);
        console.log(ciudades)
    }

    useEffect(() => {
        const personainfo = valorPersonal.valorPersonal.person
        const personaRequest = {
            Pws_Identificacion: "",
            Pws_Tip_Identificacion: "",
            Pws_Tip_Estado: "2", // Valor constante para confirmación de información.
            Pws_Tip_Perfil: "",
            Pws_Tip_person: "",
            Pws_Tip_ocupa: "",
            Pws_Nombres: "",
            Pws_Apellidos1: "",
            Pws_Apellidos2: "",
            Pws_Telefono1: "",
            Pws_Telefono2: "",
            Pws_Correo: "",
            Pws_Fec_expe: "",
            Pws_Lugar_exp: "",
            Pws_Fec_nacime: "",
            Pws_Estado_Civil: "",
            Pws_Direccion_res: "",
            Pws_Departamento: "",
            Pws_Ciudad_res: "",
            Pws_Genero: "",
            Pws_Estrato_per: "",
            Pws_Per_cargo: "",
            Pws_Tip_vivienda: "",
            Pws_Niv_estudio: "",
            Pws_Nom_empre: "",
            Pws_fec_ingemp: "",
            Pws_Fideliza: "",
            Pws_Tip_contra: "",
            Pws_Ant_labo: "",
            Pws_Car_emp: "",
            Pws_Nom_Jefedi: "",
            Pws_Direc_emp: "",
            Pws_Ciud_emp: "",
            Pws_tel_emp1: "",
            Pws_tel_emp2: "",
        }
        
        const infoUpdatePerson = { ...personaRequest, Pws_i_codigo: personainfo.Pws_i_codigo };
        DatoPersona(infoUpdatePerson)
        if (!valorPersonal.valorPersonal.update) {
            let citiesDepent = {
                "ListCiudad": {
                    "Datos_Ciudad": [] as any
                }
            }
            citiesDepent.ListCiudad.Datos_Ciudad = _.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3', s_ubicacion: persona.Pws_Departamento });
            if (citiesDepent) {
                setCiudades(citiesDepent);
            }
        }

        let citiesDepent2 = {
            "ListCiudad": {
                "Datos_Ciudad": [] as any
            }
        }
        citiesDepent2.ListCiudad.Datos_Ciudad = _.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3' });
        setCiudades2(citiesDepent2);
        setUpdate(valorPersonal.valorPersonal.update)
    }, [valorPersonal]);


    const cambios = (evento: any) => {
        var dateStart = new Date((evento.target.value).replace("-", "/"));
        var dateEnd = new Date();
        if (dateStart.getTime() > dateEnd.getTime()) {
            toast("La fecha de ingreso no debe ser mayor a la fecha actual")
        } else {
            var one_day = 1000 * 60 * 60 * 24;
            let result
            //result = Math.ceil(((dateEnd.getTime()-dateStart.getTime())/(one_day))/365)

            var results = dateEnd.getFullYear() - dateStart.getFullYear()
            let diferencia = dateEnd.getTime() - dateStart.getTime();
            let diasDeDiferencia = diferencia / 1000 / 60 / 60 / 24;
            if (diasDeDiferencia > 365 && dateStart.getMonth() <= dateEnd.getMonth() && dateStart.getDate() <= dateEnd.getDate()) {
                valorPersonal.valorPersonal.person.Pws_Ant_labo = results

            } else {
                valorPersonal.valorPersonal.person.Pws_Ant_labo = results - 1
            }
        }
    }

    const cambiarUpdat = () => {
        valorPersonal.valorPersonal.setUpdate(true)
    }
    
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log(event.target.checked)
        
        if (event.target.checked == false) {

            //Valor que trae cuando la fidelización es no

            valorPersonal.valorPersonal.person.Pws_Fideliza = "0"

            //Valor que trae cuando la fidelización es si
        } else {
            valorPersonal.valorPersonal.person.Pws_Fideliza = "1"
        }
        console.log(valorPersonal.valorPersonal.person)
        console.log(person.Pws_Fideliza)
        
    };
    return (

        <div className="box">
            <ClockLoader id='spinner' color={"#d72222"} loading={isLoading} size={100} />
            <ul className="title-punto">
                <li>1.</li>
                <li>Información personal </li>
                <Person />
                {valorPersonal.valorPersonal.arreglo.length > 3 ? <>
                    <div onClick={cambiarUpdat}>

                        <Edit />
                    </div>
                </> : <>
                </>}

            </ul>
            <div className="sub-box">

                <ul>
                    <li>
                        <label>¿Quién acredita la moto?</label>
                        {
                            update ? <>
                                <Field as="select"
                                    className="form-know-you-item-input"
                                    disabled={NoReadCedula}
                                    name="Pws_Tip_person"
                                >
                                    <option>{intl.formatMessage({ id: "placeholder_dropdown" })}</option>
                                    <option value={'N'}>{'Natural'}</option>
                                    {/* <option value={'J'}>{'Juridico'}</option> */}
                                </Field>
                            </> : <>
                                <p>{person ? (person.Pws_Tip_person === "N" ? "Natural" : "Juridico") : ""}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Tipo de ocupación</label>
                        {
                            update ? <>
                                <Field as="select"
                                    className="form-know-you-item-input"
                                    name="Pws_Tip_ocupa"
                                    required
                                    >
                                    <option>{intl.formatMessage({ id: "placeholder_dropdown" })}</option>
                                    {allOcupaciones && allOcupaciones.map((item: any, key) => {
                                        return (<option value={item.s_codigo}>{item.s_descripcion}</option>)
                                    })}
                                </Field>
                            </> : <>
                                <p>
                                    {Ocupaciones && Ocupaciones.map((item: any, key: number) => {
                                        if (Number(item.id) === Number(person.Pws_Tip_ocupa)) {
                                            return (item.name)
                                        } else {
                                            return ("")
                                        }
                                    })}</p>
                            </>
                        }
                    </li>
                    <li>
                         <label>Fidelización</label>
                               {update ? (
                                    <>
                                    <Field as="select" name="Pws_Fideliza" className="nopadding form-know-you-item-input">
                                        <option value={""}>{'Seleccione...'}</option>
                                        <option value={0}>{'No'}</option>
                                        <option value={1}>{'Sí'}</option>
                                    </Field>
                                     </>
                                       ) : (
                                        <>
                                   <p>
                                      {person && person.Pws_Fideliza == 1 ? 'Sí' : 'No'}
                                    </p>
                           </>
                         )}
                     </li>
                </ul>
            </div>
            <div className="sub-box redBox">
                <h3>Información del solicitante</h3>
                <ul>
                <li>
                        <label>Identificacion</label>
                        {
                            update ? <>
                                <Field id={'Pws_Identificacion'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Identificacion'}
                                    type={"text"}
                                    onBlur={handleSearch} 
                                    required/>
                            </> : <>
                                <p>{person ? (person.Pws_Identificacion ? person.Pws_Identificacion : "") : ""}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Tipo de identificación</label>
                        {
                            update ? <>
                                <Field as="select"
                                    className="form-know-you-item-input"
                                    name="Pws_Tip_Identificacion"
                                    required
                                    >
                                    {typeIdentification && typeIdentification.WS_TIPOS_IDENTIFICACION_IResult.LstTiposIdent.Datos_TiposIdentificacion.map((item, key) => {

                                            return (<option key={key} value={item.s_codigo}>{item.s_descripcion}</option>)

                                    })}
                                </Field>
                            </> : <>
                                <p> {typeIdentification && typeIdentification.WS_TIPOS_IDENTIFICACION_IResult.LstTiposIdent.Datos_TiposIdentificacion.map((item, key) => {
                                    if (Number(item.s_codigo) === Number(person.Pws_Tip_Identificacion)) {
                                        return (item.s_descripcion)
                                    } else {
                                        return ("");
                                    }
                                })}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Nombres</label>
                        {
                            update ? <>
                                <Field id={'Pws_Nombres'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Nombres'}
                                    type={"text"}
                                    disabled={NoReadCedula} 
                                    required/>
                            </> : <>
                                <p>{person ? (person.Pws_Nombres ? person.Pws_Nombres : "") : ""}</p>
                            </>
                        }

                    </li>
                    <li>
                        <label>Apellidos</label>
                        {
                            update ? <>
                                <Field id={'Pws_Apellidos1'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Apellidos1'}
                                    type={"text"}
                                    disabled={NoReadCedula}
                                    required />

                                <Field id={'Pws_Apellidos2'}
                                    style={{ marginTop: "5px" }}
                                    className="form-know-you-item-input"
                                    name={'Pws_Apellidos2'}
                                    type={"text"}
                                    disabled={NoReadCedula}
                                    required />
                            </> : <>
                                <p>{person ? (person.Pws_Apellidos1 ? person.Pws_Apellidos1 + " " + person.Pws_Apellidos2 : "") : ""} </p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Fecha de expedición</label>
                        {
                            update ? <>
                                <Field id={'Pws_Fec_expe'}
                                    className="form-know-you-item-input"
                                    disabled={NoReadCedula}
                                    name={'Pws_Fec_expe'}
                                    type={"date"}
                                    placeholder={'MM/dd/YYYY'} 
                                    required/>
                            </> : <>
                                <p>{person.Pws_Fec_expe ? person.Pws_Fec_expe : ""} </p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Lugar de expedición</label>
                        {
                            update ? <>
                                <Field as="select"
                                    className="form-know-you-item-input"
                                    disabled={NoReadCedula}
                                    name="Pws_Lugar_exp"
                                    required
                                >
                                    {allCities && _.filter(allCities.ListCiudad.Datos_Ciudad).map((item: any, key: number) => {
                                        return (
                                                    <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                                                )
                                    })}
                                    
                                </Field>

                            </> : <>
                                <p>{ciudades2 && ciudades2.ListCiudad.Datos_Ciudad.map((item: any, key: number) => {
                                    if (item.s_codigo === person.Pws_Lugar_exp) {
                                        return (item.s_nombre)

                                    } else {
                                        return ("")
                                    }
                                })}</p>
                            </>
                        }
                    </li>
                </ul>
                <ul>
                    <li>
                        <label>Fecha de nacimiento</label>
                        {
                            update ? <>
                                <Field id={'Pws_Fec_nacime'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Fec_nacime'}
                                    type={"date"}
                                    placeholder={'MM/dd/YYYY'}
                                    required />
                            </> : <>
                                <p>{person.Pws_Fec_nacime ? person.Pws_Fec_nacime : ""}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Estado civil</label>
                        {
                            update ? <>
                                <Field as="select"
                                    className="form-know-you-item-input"
                                    name="Pws_Estado_Civil"
                                    onChange={handleSelectChange}
                                    required
                                    >
                                    <option value="">{intl.formatMessage({ id: "placeholder_dropdown" })}</option>
                                    {EstadosCivil && EstadosCivil.map((item: any, key: any) => {
                                        return (                              
                                        <option value={item.s_codigo} key={key}>{item.s_descripcion}</option>)

                                    })}
                                </Field>
                            </> : <>
                                <p>{EstadosCivil && EstadosCivil.map((item: any, key: number) => {
                                    if (Number(item.s_codigo) === Number(person.Pws_Estado_Civil)) {
                                        return (item.s_descripcion)
                                    } else {
                                        return ("")
                                    }

                                })} </p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Dirección residencia</label>
                        {
                            update ? <>
                                <Field id={'Pws_Direccion_res'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Direccion_res'}
                                    required
                                />
                            </> : <>
                                <p>{person ? person.Pws_Direccion_res : ""}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Departamentos</label>
                        {
                            update ? <>
                                <Field as="select"
                                    className="form-know-you-item-input"
                                    name="Pws_Departamento"
                                    onClick={handleCities}
                                    required
                                >
                                    <option>{intl.formatMessage({ id: "placeholder_dropdown" })} </option>
                                    {departamentos && departamentos.ListCiudad.Datos_Ciudad.map((item: any, key: number) => {
                                        return (
                                            <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                                        )
                                    })}
                                </Field>

                            </> : <>
                                <p>{departamentos && departamentos.ListCiudad.Datos_Ciudad.map((item: any, key: number) => {
                                    if (item.s_codigo === person.Pws_Departamento) {
                                        return (item.s_nombre)
                                    } else {
                                        return ("")
                                    }
                                })}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Ciudad</label>
                        {
                            update ? <>
                                <Field as="select"
                                    className="form-know-you-item-input"
                                    name="Pws_Ciudad_res"
                                    required
                                >
                                    {ciudades && ciudades.ListCiudad.Datos_Ciudad.map((item: any, key: number) => {
                                        return (
                                            <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                                        )
                                    })}
                                </Field>

                            </> : <>
                                <p>{allCities.ListCiudad.Datos_Ciudad && allCities.ListCiudad.Datos_Ciudad.map((item: any, key: number) => {
                                    if (Number(item.s_codigo) === Number(person.Pws_Ciudad_res)) {
                                        return (item.s_nombre)

                                    } else {
                                        return ("")
                                    }
                                })}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Teléfono móvil 1</label>
                        {
                            update ? <>
                                <Field id={'Pws_Telefono1'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Telefono1'}
                                    required
                                />
                            </> : <>
                                <p>{person ? person.Pws_Telefono1 : ""} </p>
                            </>
                        }
                    </li>
                </ul>
                <ul>
                    <li>
                        <label>Teléfono móvil 2</label>
                        {
                            update ? <>
                                <Field id={'Pws_Telefono2'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Telefono2'}
                                    required
                                />
                            </> : <>
                                <p>{person ? person.Pws_Telefono2 : ""}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Email</label>
                        {
                            update ? <>
                                <Field id={'Pws_Correo'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Correo'}
                                    required={true}
                                />
                            </> : <>
                                <p>{person ? person.Pws_Correo : ""} </p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Género</label>
                        {
                            update ? <>
                                <Field as="select"
                                    className="form-know-you-item-input"
                                    name="Pws_Genero"
                                    required
                                    >
                                    <option>{intl.formatMessage({ id: "placeholder_dropdown" })}</option>
                                    <option value={'F'}>{'Femenino'}</option>
                                    <option value={'M'}>{'Masculino'}</option>
                                    <option value={'T'}>{'Transexual'}</option>
                                    <option value={'NB'}>{'No Binario'}</option>
                                </Field>
                            </> : <>
                            <p>{person ? (person.Pws_Genero === "F" ? "Femenino" : (person.Pws_Genero === "M" ? "Masculino" : (person.Pws_Genero === "T" ? "Transexual" : (person.Pws_Genero === "NB" ? "No Binario" : "")))) : ""}</p>

                            </>
                        }
                    </li>
                    <li>
                        <label>Estrato social</label>
                        {
                            update ? <>
                                <Field as="select"
                                            className="form-know-you-item-input"
                                            name="Pws_Estrato_per"
                                            required
                                        >
                                    <option>{intl.formatMessage({ id: "placeholder_dropdown" })}</option>
                                    {estractos && estractos.WS_ESTRACTOS_SOCResult.estratos_soc.Datos_estratos_soc.map((item, key) => {
                                        return (<option value={item.i_codigo}>{item.c_descripcion}</option>)

                                    })}
                                </Field>
                            </> : <>
                                <p> {estractos && estractos.WS_ESTRACTOS_SOCResult.estratos_soc.Datos_estratos_soc.map((item, key: number) => {
                                    if (Number(item.i_codigo) === Number(person.Pws_Estrato_per)) {
                                        return (item.c_descripcion)
                                    } else {
                                        return ("")

                                    }
                                })} </p>
                            </>
                        }

                    </li>
                    <li>
                        <label>N° de personas a cargo</label>
                        {
                            update ? <>
                                <Field as="select"
                                    className="form-know-you-item-input"
                                    name="Pws_Per_cargo"
                                    required
                                    >
                                    <option>{intl.formatMessage({ id: "placeholder_dropdown" })}</option>
                                    <option value={'0'}>{'0'}</option>
                                    <option value={'1'}>{'1'}</option>
                                    <option value={'2'}>{'2'}</option>
                                    <option value={'3'}>{'3'}</option>
                                    <option value={'4'}>{'4'}</option>
                                    <option value={'5'}>{'5'}</option>
                                    <option value={'6'}>{'6'}</option>
                                    <option value={'7'}>{'7'}</option>
                                    <option value={'8'}>{'8'}</option>
                                    <option value={'9'}>{'9'}</option>
                                    <option value={'10'}>{'10'}</option>
                                </Field>
                            </> : <>
                                <p>{person ? person.Pws_Per_cargo : ""}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Tipo de vivienda </label>
                        {
                            update ? <>
                                <Field as="select"
                                    className="form-know-you-item-input"
                                    disabled={NoReadCedula}
                                    name="Pws_Tip_vivienda"
                                    required
                                    >
                                    <option>{intl.formatMessage({ id: "placeholder_dropdown" })}</option>
                                    {tipovivi && tipovivi.map((item: any, key) => {

                                        return (<option value={item.i_codigo}>{item.c_descripcion}</option>)

                                    })}
                                </Field>
                            </> : <>
                                <p>{tipovivi && tipovivi.map((item: any, key: number) => {
                                    if (Number(item.i_codigo) === Number(person.Pws_Tip_vivienda)) {
                                        return (item.c_descripcion)
                                    } else {
                                        return ("")

                                    }
                                })}  </p>
                            </>
                        }

                    </li>
                    <li>
                        <label>Nivel de estudios </label>
                        {
                            update ? <>
                                <Field as="select"
                                    className="form-know-you-item-input"
                                    name="Pws_Niv_estudio"
                                    required
                                    >
                                    <option>{intl.formatMessage({ id: "placeholder_dropdown" })}</option>
                                    {NivelEsti && NivelEsti.map((item: any, key) => {

                                        return (<option value={item.s_codigo}>{item.s_descripcion}</option>)

                                    })}
                                </Field>
                            </> : <>
                                <p> {NivelEsti && NivelEsti.map((item: any, key: number) => {
                                    if (Number(item.s_codigo) === Number(person.Pws_Niv_estudio)) {
                                        return (item.s_descripcion)
                                    } else {
                                        return ("")

                                    }
                                })}</p>
                            </>
                        }

                    </li>
                    <FormSpouseCodeudor dataConyuge={dataConyuge} values={person} show={modal} onHide={toggle} solicitud={valorPersonal.valorPersonal.arreglo[0]} />
                </ul>
            </div>
            <div className="sub-box redBox">
                <h3>Actividad del solicitante</h3>
                <ul>
                    <li>
                        <label>Nombre de la Compañia</label>
                        {
                            update ? <>
                                <Field id={'Pws_Nom_empre'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Nom_empre'}
                                    required
                                />
                            </> : <>
                                <p>{person ? person.Pws_Nom_empre : ""}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Fecha de ingreso</label>
                        {
                            update ? <>
                                <Field id={'Pws_fec_ingemp'}
                                    className="form-know-you-item-input"
                                    name={'Pws_fec_ingemp'}
                                    type={"date"}
                                    onBlur={cambios}
                                    placeholder={'MM/dd/YYYY'} 
                                    required
                                    />
                            </> : <>
                                <p>{person.Pws_fec_ingemp ? new Date(person.Pws_fec_ingemp).toLocaleDateString() : ""}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Tipo de contrato</label>
                        {
                            update ? <>
                                <Field as="select"
                                    name="Pws_Tip_contra"
                                    required
                                    >
                                    <option>{intl.formatMessage({ id: "placeholder_dropdown" })}</option>
                                    {TipoContrato && TipoContrato.map((item: any, key: any) => {

                                        return (<option value={item.s_codigo} key={key}>{item.s_descripcion}</option>)

                                    })}
                                </Field>
                            </> : <>
                                <p>{TipoContrato && TipoContrato.map((item: any, key: number) => {
                                    if (Number(item.s_codigo) === Number(person.Pws_Tip_contra)) {
                                        return (item.s_descripcion)
                                    } else {
                                        return ("")

                                    }
                                })} </p>
                            </>
                        }

                    </li>
                    <li>
                        <label>Antigüedad laboral (años)</label>
                        {
                            update ? <>
                                <Field id={'Pws_Ant_labo'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Ant_labo'}
                                    required
                                />
                            </> : <>
                                <p>{person ? person.Pws_Ant_labo : ""} año </p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Cargo que desempeña</label>
                        {
                            update ? <>
                                <Field id={'Pws_Car_emp'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Car_emp'}
                                    required
                                />
                            </> : <>
                                <p>{person ? person.Pws_Car_emp : ""}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Jefe directo</label>
                        {
                            update ? <>
                                <Field id={'Pws_Nom_Jefedi'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Nom_Jefedi'}
                                    required
                                />
                            </> : <>
                                <p>{person ? person.Pws_Nom_Jefedi : ""}</p>
                            </>
                        }
                    </li>
                </ul>
                <ul>
                    <li>
                        <label>Dirección de la empresa</label>
                        {
                            update ? <>
                                <Field id={'Pws_Direc_emp'}
                                    className="form-know-you-item-input"
                                    name={'Pws_Direc_emp'}
                                    required
                                />
                            </> : <>
                                <p>{person ? person.Pws_Direc_emp : ""} </p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Ciudad</label>
                        {
                            update ? <>
                                <Field as="select"
                                    className="form-know-you-item-input"
                                    name="Pws_Ciud_emp"
                                    required
                                >
                                    {_.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3' }) && _.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3' }).map((item: any, key: number) => {
                                        return (
                                            <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                                        )
                                    })}
                                </Field>

                            </> : <>
                                <p>{_.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3' }).map((item: any, key: number) => {
                                    if (item.s_codigo === person.Pws_Ciud_emp) {
                                        return (item.s_nombre)

                                    } else {
                                        return ("")
                                    }
                                })}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Teléfono 1</label>
                        {
                            update ? <>
                                <Field id={'Pws_tel_emp1'}
                                    className="form-know-you-item-input"
                                    name={'Pws_tel_emp1'}
                                    required
                                />
                            </> : <>
                                <p>{person ? person.Pws_tel_emp1 : ""}</p>
                            </>
                        }
                    </li>
                    <li>
                        <label>Teléfono 2</label>
                        {
                            update ? <>
                                <Field id={'Pws_tel_emp2'}
                                    className="form-know-you-item-input"
                                    name={'Pws_tel_emp2'}
                                    required
                                />
                            </> : <>
                                <p>{person ? person.Pws_tel_emp2 : ""} </p>
                            </>
                        }
                    </li>
                </ul>
            </div>
        </div>
    );
}
export const Box8 = (valorFinancie: any) => {
    const [option1, setoption1] = React.useState(false);
    const [option2, setoption2] = React.useState(false);
    const [option3, setoption3] = React.useState(false);
    const [option4, setoption4] = React.useState(false);
    const [option5, setoption5] = React.useState(false);

    const [option1s, setoption1s] = React.useState({} as any);
    const [option2s, setoption2s] = React.useState({} as any);
    const [option3s, setoption3s] = React.useState({} as any);
    const [option4s, setoption4s] = React.useState({} as any);
    const [option5s, setoption5s] = React.useState({} as any);

    useEffect(() => {
        if (valorFinancie.valorFinancie.datosdocuments.length > 0) {
            valorFinancie.valorFinancie.datosdocuments.forEach((element: any) => {
                if (Number(element.Pws_Doc_Tipo) == 1) {
                    setoption1(true)
                    setoption1s(element)
                } else if (Number(element.Pws_Doc_Tipo) == 2) {
                    setoption2(true)
                    setoption2s(element)

                } else if (Number(element.Pws_Doc_Tipo) == 3) {
                    setoption3(true)
                    setoption3s(element)

                }else if (Number(element.Pws_Doc_Tipo) == 4) {
                    setoption4(true)
                    setoption4s(element)

                }else if (Number(element.Pws_Doc_Tipo) == 12) {
                    setoption5(true)
                    setoption5s(element)

                }

            });
        }
        if (valorFinancie.valorFinancie.update && valorFinancie.valorFinancie.arreglo.length > 3) {
            setoption1(false)
            setoption3(false)
            setoption2(false)
            setoption4(false)
            setoption5(false)
        }        
    }, [valorFinancie.valorFinancie])
    const handleFileInputChange = (e: any) => {
        const target = e.target
        if (target.files && target.files[0]) {
            const maxAllowedSize = 5 * 1024 * 1024;
            if (target.files[0].size > maxAllowedSize) {
                toast.error('Seleccione un archivo de tamaño máximo 5mb.');
                target.value = ''
            }
        }
        let file: any = '';
        file = e.target.files[0];
        const dataElement = target.closest("[data-id]");
        if (Number(dataElement.dataset.id) === 1) {
            setoption1(true)
        }
        if (Number(dataElement.dataset.id) === 2) {
            setoption2(true)
        }
        if (Number(dataElement.dataset.id) === 3) {
            setoption3(true)
        }
        if (Number(dataElement.dataset.id) === 4) {
            setoption4(true)
        }
        if (Number(dataElement.dataset.id) === 12) {
            setoption5(true)
        }

    };

    ;
    return (
        <div className="footer">
            <div className="footer-text">
                <h4>Adjuntar documentos</h4>
                <p><span>{`Documetación requerida`}</span>{`(Los documentos. Se permiten PDF, JPG Y PNG. Tamaño máximo de 5Mb) `}</p>
            </div>
            <div className="footer-body">
                <div className={option1 ? "document check" : "document"} onClick={(eve) => {
                    if (option1) {
                        if (option1s.Pws_Clave_doc) {
                            const link = document.createElement('a');
                            link.href = option1s.Pws_Clave_doc;
                            link.setAttribute(
                                'download',
                                option1s.Pws_Doc_nombre,
                            );
                            link.setAttribute("target", "_blank")
                            // Append to html link element page
                            document.body.appendChild(link);

                            // Start download
                            link.click();
                            link.remove();
                        } else {
                            eve.currentTarget.querySelector('input')?.click()
                        }

                    } else {
                        eve.currentTarget.querySelector('input')?.click()

                    }
                }}>
                    <input

                        data-id="1"
                        type="file"
                        name="file-input"
                        id="file-input"
                        className="file-input__input"

                        accept="application/pdf, image/png, image/jpg, image/jpeg"
                        onChange={handleFileInputChange}
                    />
                    {option1 ? <><Check /></> : <><Document /></>}
                    <p>Copia de cedula</p>
                </div>
                <div className={option2 ? "document check" : "document"} onClick={(eve) => {
                    if (option2) {
                        if (option2s.Pws_Clave_doc) {

                            const link = document.createElement('a');
                            link.href = option2s.Pws_Clave_doc;
                            link.setAttribute(
                                'download',
                                option2s.Pws_Doc_nombre,
                            );
                            link.setAttribute("target", "_blank")
                            // Append to html link element page
                            document.body.appendChild(link);

                            // Start download
                            link.click();
                            link.remove();
                        } else {
                            eve.currentTarget.querySelector('input')?.click()

                        }
                    } else {
                        eve.currentTarget.querySelector('input')?.click()

                    }
                }}>
                    <input
                        data-id="2"
                        type="file"
                        name="file-input"
                        id="file-input"
                        className="file-input__input"

                        accept="application/pdf, image/png, image/jpg, image/jpeg"
                        onChange={handleFileInputChange}
                    />
                    {option2 ? <><Check /></> : <><Document /></>}

                    <p>Recibo de servicio publico</p>
                </div>
                <div className={option3 ? "document check" : "document"} onClick={(eve) => {
                    if (option3) {
                        if (option3s.Pws_Clave_doc) {
                            const link = document.createElement('a');
                            link.href = option3s.Pws_Clave_doc;
                            link.setAttribute(
                                'download',
                                option3s.Pws_Doc_nombre,
                            );
                            link.setAttribute("target", "_blank")
                            // Append to html link element page
                            document.body.appendChild(link);

                            // Start download
                            link.click();
                            link.remove();
                        } else {
                            eve.currentTarget.querySelector('input')?.click()

                        }

                    } else {
                        eve.currentTarget.querySelector('input')?.click()

                    }
                }}>
                    <input
                        data-id="3"
                        type="file"
                        name="file-input"
                        id="file-input"
                        className="file-input__input"

                        accept="application/pdf, image/png, image/jpg, image/jpeg"
                        onChange={handleFileInputChange}
                    />
                    {option3 ? <><Check /></> : <><Document /></>}
                    <p>Soportes de ingresos y/o garantías</p>
                </div>
    
                <div className={option5 ? "document check" : "document"} onClick={(eve) => {
                    if (option5) {
                        if (option5s.Pws_Clave_doc) {

                            const link = document.createElement('a');
                            link.href = option5s.Pws_Clave_doc;
                            link.setAttribute(
                                'download',
                                option5s.Pws_Doc_nombre,
                            );
                            link.setAttribute("target", "_blank")
                            // Append to html link element page
                            document.body.appendChild(link);

                            // Start download
                            link.click();
                            link.remove();
                        } else {
                        }
                    } else {

                    }
                }}>
                    <input
                        data-id="12"
                        type="file"
                        name="file-input"
                        id="file-input"
                        className="file-input__input"

                        accept="application/pdf, image/png, image/jpg, image/jpeg"
                        //onChange={handleFileInputChange}
                    />
                    {option5 ? <><Check /></> : <><Document /></>}
                    <p>Documento Firmado</p>
                </div>
            </div>
        </div>
    )
}
export const Box3 = (props: { valorFinancie: any, updateValorFinancie: (field: string, value: any) => void }) => {
    const { valorFinancie, updateValorFinancie } = props;
    const { valorinic } = valorFinancie
    const [update, setUpdate] = React.useState(false);
    const [numeroSolicitud, setnumeroSolicitud] = React.useState(true);
    const [referenciasFiltered, setReferenciasFiltered] = React.useState("");
    const [showAdditionalFields, setShowAdditionalFields] = useState(false);
    const intl = useIntl();
    const [showFields, setShowFields] = useState(true);
    const [values, setValues] = useState({
        s_pep_nompepseg: '',
        parentesco: '',
        s_pep_identif: '',
    });
    
    useEffect(() => {
        setUpdate(valorFinancie.update)
        if (valorFinancie.datopeps) {
          setValues((prevValues:any) => ({
            ...prevValues,
            ...valorFinancie.datopeps
          }));
        }
      }, [valorFinancie]);

      const referencias = async () => {
        console.log('---------------------------------------------------------------------------------');
        try {
          const response = await AdminService.getReferencias();
          const datosReferencias = response?.payload?.data?.ListRef?.Datos_Referencias;
          
          if (!Array.isArray(datosReferencias)) {
            console.error('Datos_Referencias no es un array o no existe');
            return;
          }
      
          const referenciaFiltro = datosReferencias.find((item: { s_codigo: string; s_descripcion: string }) =>
            item.s_codigo === valorFinancie?.valorFinancie?.datopeps?.Pws_Pep_paren
          );
      
          console.log(referenciaFiltro);
      
          if (referenciaFiltro) {
            setReferenciasFiltered(referenciaFiltro.s_descripcion);
          } else {
            console.log('No se encontró ninguna referencia que coincida');
            // Manejar el caso cuando no se encuentra una referencia
          }
        } catch (error) {
          console.error('Error al obtener referencias:', error);
          // Manejar el error apropiadamente
        }
      };
      
      const handleSwitchChange = (field: string, event?: any) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.checked;
        const datopepsField = field;
        updateValorFinancie(datopepsField, newValue);  
        
        if (field === 's_pep_pubexpue') {
            setShowAdditionalFields(newValue);
        }
    };

      const handleChange = (e: any) => {
        setValues({
          ...valorinic,
          [e.target.name]: e.target.value,
        });
      };

      const handleSubmit = () => {
        // Actualiza `valorFinancie` con los valores de `values`
        updateValorFinancie('datopeps', valorinic);
        console.log('Datos guardados:', valorinic); // Puedes eliminar esto si no necesitas el log
    };
    const onSubmit = async (values: any, formikBag: { setSubmitting: any }) => {
        setnumeroSolicitud(values.s_num_solicitud);
        const operFinancieras = {
            s_num_solicitud: values.s_num_solicitud,
            s_identificacion: values.s_identificacion,
            s_tipo_identificacion: values.s_tipo_identificacion,
            s_ingreso_principal: values.s_ingreso_principal,
            s_otros_ingresos: values.s_otros_ingresos,
            s_otros_egresos: values.s_otros_egresos,
            s_arriendo: values.s_arriendo,
            s_concep_otr_ingre: values.s_concep_otr_ingre,
            s_declarante_ren: values.s_declarante_ren ? '1' : '0',
            s_moneda_ext: values.s_moneda_ext ? '1' : '0',
            s_monext_oper: values.s_monext_oper,
            s_tip_monext: values.s_tip_monext,
            s_cuent_ext: values.s_cuent_ext ? '1' : '0',
            s_cuen_extban: values.s_cuen_extban,
            s_cuen_extnum: values.s_cuen_extnum,
            s_cuen_extpais: values.s_cuen_extpais,
            s_cuen_extciudad: values.s_cuen_extciudad,
        };
        const result2 = await WLOCreditAPIService.addFinancialInformation(operFinancieras);
        const peps = {
            s_num_solicitud: values.s_num_solicitud,
            s_identificacion: values.s_identificacion,
            s_tipo_identificacion: values.s_tipo_identificacion,
            s_pep_recpublic: values.s_pep_recpublic ? '1' : '0',
            s_pep_poderpublic: values.s_pep_poderpublic ? '1' : '0',
            s_pep_reconpublic: values.s_pep_reconpublic ? '1' : '0',
            s_pep_pubexpue: values.s_pep_pubexpue ? '1' : '0',
            s_pep_seggraconsa: values.s_pep_seggraconsa ? '1' : '0',
            s_pep_nompepseg: values.s_pep_nompepseg,
            s_pep_paren: values.s_pep_paren,
            s_pep_identif: values.s_pep_identif,
        };
        const result = await WLOCreditAPIService.addPeps(peps);
        const cygnus = await WLOCreditAPIService.grabar_cignus({
            Pws_Identificacion: values.s_identificacion,
            Pws_Tip_Identificacion: values.s_tipo_identificacion,
            Pws_Tip_Perfil: '2',
        });
        valorFinancie.valorFinancie.Busquedatotal();
        toast('Actualizado correctamente');
    };

    return (
        <div className="box">
            <ul className="title-punto">
                <li>2.</li>
                <li>Información financiera </li>
                <Doc />
            </ul>
            <div className="sub-box redBox">
                <h3>Ingresos del solicitante</h3>
                <ul>
                    <li>
                        <label>Ingreso principal</label>
                        {
                            update ?
                                <>
                                    <Field id="s_ingreso_principal"
                                        name="s_ingreso_principal"
                                        component={ParseNumberThousand} 
                                        required
                                        />
                                </> : <>
                                    <p>{valorinic.s_ingreso_principal} </p>
                                </>
                        }

                    </li>
                    <li>
                        <label>Otros ingresos</label>
                        {
                            update ?
                                <>
                                    <Field id="s_otros_ingresos"
                                        name="s_otros_ingresos"
                                        component={ParseNumberThousand}
                                        required
                                        />
                                </> : <>
                                    <p>{valorinic.s_otros_ingresos} </p>
                                </>
                        }
                    </li>
                    <li>
                        <label>Valor egresos</label>
                        {
                            update ?
                                <>
                                    <Field id="s_otros_egresos"
                                        name="s_otros_egresos"
                                        component={ParseNumberThousand}
                                        required
                                        />
                                </> : <>
                                    <p>{valorinic.s_otros_egresos}</p>
                                </>
                        }
                    </li>
                    <li>
                        <label>Concepto de otros ingresos</label>
                        {
                            update ?
                                <>
                                    <Field id="s_concep_otr_ingre"
                                        className="form-know-you-item-input"
                                        name="s_concep_otr_ingre"
                                        type="text" 
                                        required
                                        />
                                </> : <>
                                    <p>{valorinic.s_concep_otr_ingre}</p>
                                </>
                        }
                    </li>
                    <li>
                        <label>Declarante de renta</label>
                        {
                            update ?
                                <>
                                    <div >
                                        No
                                        <Field id={'s_declarante_ren'}
                                            name="s_declarante_ren" component={Switch}
                                            type="checkbox" onChange={handleSwitchChange('s_declarante_ren')} />
                                        Si
                                    </div>

                                </> : <>
                                    <FUllPill check={valorinic.s_declarante_ren} disabled={true} id={"s_declarante_ren"} name={"s_declarante_ren"} />
                                </>
                        }
                    </li>
                </ul>
            </div>
            <div className="sub-box redBox">
                <h3> Operaciones Financieras </h3>
                <div className="pillInfo">
                    <p>¿Realizas operaciones en moneda extranjera?</p>
                    {
                         update ?
                         <>
                             <div >
                                 No
                                 <Field id={'s_cuent_ext'}
                                     name="s_cuent_ext" component={Switch} type="checkbox"
                                     onChange={handleSwitchChange('s_cuent_ext')}
                                     />
                                 Si
                             </div>

                         </> : <>
                                <FUllPill check={valorinic.s_moneda_ext} disabled={false} id={'s_moneda_ext'}
                                    name={'s_moneda_ext'} />
                            </>
                    }
                </div>
                <div className="pillInfo">
                    <p>Posees cuentas en moneda extranjera</p>
                    {
                        update ?
                            <>
                                <div >
                                    No
                                    <Field id={'s_cuent_ext'}
                                        name="s_cuent_ext" component={Switch} type="checkbox"
                                        onChange={handleSwitchChange('s_cuent_ext')}
                                        />
                                    Si
                                </div>

                            </> : <>
                                <FUllPill check={valorinic.s_cuent_ext} disabled={true} id={"s_cuent_ext"} name={"s_cuent_ext"} />
                            </>
                    }
                </div>
                <h3>{`Información PEP. (Personas expuestas Políticamente)`}</h3>
                <div className="pillInfo">
                    <p>¿Por tu cargo manejas recursos públicos? </p>
                    {
                        update ?
                            <>
                                <div >
                                    No
                                    <Field id={'s_pep_recpublic'}
                                        name="s_pep_recpublic" component={Switch}
                                        type="checkbox" onChange={handleSwitchChange('s_pep_recpublic')}/>
                                    Si
                                </div>

                            </> : <>
                                <FUllPill check={valorinic.s_pep_recpublic} disabled={true} id={"s_pep_recpublic"} name={"s_pep_recpublic"} />
                            </>
                    }
                </div>
                <div className="pillInfo">
                    <p>¿Por tu cargo o actividad ejerces algún grado de poder público? </p>
                    {
                        update ?
                            <>
                                <div >
                                    No
                                    <Field id={'s_pep_poderpublic'}
                                        name="s_pep_poderpublic" component={Switch}
                                        type="checkbox" onChange={handleSwitchChange('s_pep_poderpublic')}/>
                                    Si
                                </div>

                            </> : <>
                                <FUllPill check={valorinic.s_pep_poderpublic} disabled={true} id={"s_pep_poderpublic"} name={"s_pep_poderpublic"} />
                            </>
                    }
                </div>
                <div className="pillInfo">
                    <p>¿Gozas de reconocimiento público? </p>{
                        update ?
                            <>
                                <div >
                                    No
                                    <Field id={'s_pep_reconpublic'}
                                        name="s_pep_reconpublic" component={Switch}
                                        type="checkbox" onChange={handleSwitchChange('s_pep_reconpublic')} />
                                    Si
                                </div>

                            </> : <>
                                <FUllPill check={valorinic.s_pep_reconpublic} disabled={true} id={"s_pep_reconpublic"} name={"s_pep_reconpublic"} />
                            </>
                    }
                </div>
                <div className="pillInfo">
                    <p>¿Eres familiar de alguna persona políticamente expuesta? </p>
                    {
                        update ?
                            <>
                                <div>
                                    No
                                    <Field id={'s_pep_pubexpue'}
                                        name="s_pep_pubexpue" component={Switch}
                                        type="checkbox" onChange={handleSwitchChange('s_pep_pubexpue')}/>
                                    Si
                                </div>

                            </> : <>
                                <FUllPill check={valorinic.s_pep_pubexpue} disabled={true} id={"s_pep_pubexpue"} name={"s_pep_pubexpue"} />
                            </>
                    }
                </div>
                <div className="pillInfo">
                    <p>{`¿Tienes 2° de afinidad y 2° de consanguinidad (Padres, hermanos, esposa, primos, suegros, cuñados o concuñados) con PEP?`}</p>
                        {update ? (
                      <>
                       <div>
                            No
                            <Field 
                                id="s_pep_segraconsa"
                                name="s_pep_segraconsa"
                                component={Switch}
                                type="checkbox"
                                onChange={() => handleSwitchChange('s_pep_segraconsa')}
                            />
                            Si
                            </div>
                     </>
                    ) : (
                    <FUllPill check={valorinic.s_pep_seggraconsa} disabled={true} id={"s_pep_seggraconsa"} name={"s_pep_seggraconsa"} />
                 )}
                    </div>
                    {showFields && (
                                <div className="campos-adicionales">
                        <div className="campo">
                        <label htmlFor="nombre_familiar" className="label-pep">
                            Nombre del Familiar:
                        </label>
                        <Field
                            type="text"
                            id="nombre_familiar"
                            className="valor-pep"
                            name="s_pep_nompepseg"
                        />
                        </div>
                        <div className="campo">
                        <label htmlFor="parentesco" className="label-pep">
                            {intl.formatMessage({ id: "relationship" })}
                        </label>
                        <Field as="select" name="s_pep_paren" className="valor-pep">
                            <option value="">{intl.formatMessage({ id: "relationship" })}</option>
                            {Parentescos.map((valor) => (
                            <option key={valor.id} value={valor.id}>
                                {valor.name}
                            </option>
                            ))}
                        </Field>
                        </div>

                    <div className="campo">
                        <label htmlFor="cedula_pep" className="label-pep">Cédula PEP:</label>
                    <Field
                        type="text"
                        id="cedula_pep"
                        className="valor-pep"
                        name="s_pep_identif"
                        />
                        </div>
                </div>
                    )}
            </div>  
                    <button type="submit" id="botonSubmit2" style={{ display: 'none' }}></button>
            </div>
            );
        }
interface RenderContainerProps {
    setPopup: React.Dispatch<React.SetStateAction<string>>;
}
export const Box5 = (valorReferencias: any) => {
    const [valuesInicial, valorInicial] = React.useState({});
    const [modalShow, setModalShow] = React.useState(false);
    const [listReferencias, setListReferen] = useState([])
    const [datosReferenciaPersonales, ReferenciaPersonales] = React.useState([]);
    const [one] = useState(false);
    const toggle = () => {
        setModalShow(!modalShow);
        DatosReferenciasPersonales(
            valorReferencias.valorReferencias.arreglo[0],
            valorReferencias.valorReferencias.person.Pws_Identificacion,
            valorReferencias.valorReferencias.person.Pws_Tip_Identificacion)
    };


    useEffect(() => {
        ReferenciaPersonales(valorReferencias.valorReferencias.datosrefe)
    }, [valorReferencias]);

    useEffect(() => {
        getAll()
    }, [one])

    const intl = useIntl();

    const getAll = async () => {
        const refer = await AdminService.getReferencias();
        if (refer.payload.data.ListRef.Datos_Referencias.length > 0) {
            setListReferen(refer.payload.data.ListRef.Datos_Referencias)
        }
    }
    const DatosReferenciasPersonales = async (solicitud: string, identificacion: string, tipo_identificacion: string) => {
        const referencias1 = await WLOCreditAPIService.addReferences({
            s_num_solicitud: solicitud!,
            s_identificacion: identificacion!,
            s_tipo_identificacion: tipo_identificacion!,
            s_ref_tipo: "",
            s_ref_parentes: "",
            s_ref_nomcomple: "",
            s_ref_telfij: "",
            s_ref_telcel: ""
        })
        if (referencias1.payload.result === "1") {
            ReferenciaPersonales(referencias1.payload.data.datos_referencia.datos_refer)
        }
    }

    const ListItem: React.FC<any> = ({ info }) => {
        if (info) {
            let ref = (info.i_ref_tip == 1 ? 'FAMILIAR' : 'PERSONAL')
            let parent = info.n_pws_vinculo
            let nomcom = (info.c_pws_ref_nomcomple)
            let telf = (info.i_pws_ref_telfu)
            let telmo = (info.i_pws_ref_telcle)
            return (
                <ul>
                    <li className="listItem">{ref}</li>
                    <li className="listItem">{parent}</li>
                    <li className="listItem">{nomcom}</li>
                    <li className="listItem">{telf}</li>
                    <li className="listItem">{telmo}</li>
                </ul>
            )
        } else {
            return (<></>)
        }
    }
    return (
        <div className="box">
            <ul className="title-punto">
                <li>3.</li>
                <li>Referencias </li>
            </ul>
            <div className="table">
                {/* <ReferenceTable references={{refer:referencias,Busquedatotals,values:valorReferencias.valorReferencias.datosValorRefer,codeudor:true}}/> */}
                <div className="referenceTable">
                    <div className="table">
                        <div className="responsiveFix">
                            <div className="responsiveAuto">
                                <ul>
                                    <li className="listItem listHeader">Tipo de referencia</li>
                                    <li className="listItem listHeader">Parentesco</li>
                                    <li className="listItem listHeader">Nombre completo</li>
                                    <li className="listItem listHeader">{`Teléfono fijo (Si tiene)`}</li>
                                    <li className="listItem listHeader">Teléfono movil</li>
                                </ul>
                                {
                                    datosReferenciaPersonales.map((info, i) => {
                                        return (
                                            <ListItem key={i} info={info} />
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className="agregar">
                            <button type='button' onClick={() => { setModalShow(!modalShow) }}>Agregar</button>
                        </div>
                    </div>
                    <ModalReferencesCodeudor
                        valuesperson={valorReferencias.valorReferencias.person}
                        solicitud={valorReferencias.valorReferencias.arreglo[0]}
                        values={valorReferencias.valorReferencias.datosValorRefer}
                        show={modalShow}
                        onHide={toggle}
                    />
                </div>
            </div>
        </div>
    );
}

export const Box4 = (valorDocuments: any) => {
    const [update, setUpdate] = React.useState(false);
    const [UpdateDocumentosLegales, setUpdateDocumentosLegales] = React.useState(false);
    const [alldocuments, setDocuments] = React.useState([{
        Pws_Doc_Tipo: 1,
        Pws_Doc_nombre: "",
        Pws_Clave_doc: "",
        Pws_Doc_estado: "",
        Pws_Doc_ruta: ""
    }, {
        Pws_Doc_Tipo: 2,
        Pws_Doc_nombre: "",
        Pws_Clave_doc: "",
        Pws_Doc_estado: "",
        Pws_Doc_ruta: ""
    }, {
        Pws_Doc_Tipo: 3,
        Pws_Doc_nombre: "",
        Pws_Clave_doc: "",
        Pws_Doc_estado: "",
        Pws_Doc_ruta: ""
    }, {
        Pws_Doc_Tipo: 4,
        Pws_Doc_nombre: "",
        Pws_Clave_doc: "",
        Pws_Doc_estado: "",
        Pws_Doc_ruta: ""
    }, {
        Pws_Doc_Tipo: 5,
        Pws_Doc_nombre: "",
        Pws_Clave_doc: "",
        Pws_Doc_estado: "",
        Pws_Doc_ruta: ""
    }]);
    const { user, setUser } = useLoginContext();
    useEffect(() => {
        if (valorDocuments.valorDocuments.alldocuments) {
            if (valorDocuments.valorDocuments.alldocuments.length > 0) {
                let valordocumentos = [{
                    Pws_Doc_Tipo: 1,
                    Pws_Doc_nombre: "",
                    Pws_Clave_doc: "",
                    Pws_Doc_estado: "",
                    Pws_Doc_ruta: ""
                }, {
                    Pws_Doc_Tipo: 2,
                    Pws_Doc_nombre: "",
                    Pws_Clave_doc: "",
                    Pws_Doc_estado: "",
                    Pws_Doc_ruta: ""
                }, {
                    Pws_Doc_Tipo: 3,
                    Pws_Doc_nombre: "",
                    Pws_Clave_doc: "",
                    Pws_Doc_estado: "",
                    Pws_Doc_ruta: ""
                }, {
                    Pws_Doc_Tipo: 4,
                    Pws_Doc_nombre: "",
                    Pws_Clave_doc: "",
                    Pws_Doc_estado: "",
                    Pws_Doc_ruta: ""
                }, {
                    Pws_Doc_Tipo: 5,
                    Pws_Doc_nombre: "",
                    Pws_Clave_doc: "",
                    Pws_Doc_estado: "",
                    Pws_Doc_ruta: ""
                }] as any
                valorDocuments.valorDocuments.alldocuments.forEach((element: any) => {
                    if (element.Pws_Doc_estado == "1") valordocumentos[Number(element.Pws_Doc_Tipo) - 1] = element
                });
                setDocuments(valordocumentos)
            }
        }
    }, [valorDocuments]);
    const cambiarUpdat = () => {
        if (update) {
            valorDocuments.valorDocuments.Busquedatotal()
        }
        setUpdate(!update)
    }

    const handleFileInputChange = (e: any) => {
        const target = e.target
        if (target.files && target.files[0]) {
            const maxAllowedSize = 5 * 1024 * 1024;
            if (target.files[0].size > maxAllowedSize) {
                toast.error('Seleccione un archivo de tamaño máximo 5mb.');
                target.value = ''
            }
        }
        let file: any = '';
        file = e.target.files[0];
        getBase64(file)
            .then(async result => {
                const document = result as string;
                const documentRequest = {
                    Pws_num_solicitud: valorDocuments.valorDocuments.valor[0],
                    Pws_Identificacion: valorDocuments.valorDocuments.valorCodeudor.cedula,
                    Pws_Tip_Identificacion: valorDocuments.valorDocuments.valorCodeudor.type,
                    Pws_Doc_Tipo: target.dataset.id,
                    Pws_Doc_nombre: file.name,
                    Pws_Doc_estado: "1",
                    Pws_Doc_ruta: "1",
                    Pws_Clave_doc: document,
                };
                (async () => {
                    const solicitud = await WLOCreditAPIService.addDocuments(documentRequest);
                    if (Number(solicitud.payload.result) > 0) {
                        toast.success("Subido el Nuevo Archivo")
                    }

                })();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getBase64 = (file: any) => {
        return new Promise(resolve => {
            let baseURL: string | ArrayBuffer | null = "";
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    };
    return (
        <div className="box">
            <ul className="title">
                <li>4.</li>
                <li>Documentos de la solicitud </li>
                <File />
                <div onClick={cambiarUpdat}>
                    <Edit />
                </div>
            </ul>
            <div className="documents">
                {alldocuments.map((valorDocumentss: any, index) => {
                    let tipo = ""
                    let documentss = ""
                    let pasar = true;
                    if (Number(valorDocumentss.Pws_Doc_Tipo) == 1) {
                        tipo = "Copia de Cedula"
                        documentss = valorDocumentss.Pws_Doc_nombre
                    } else if (Number(valorDocumentss.Pws_Doc_Tipo) == 2) {
                        tipo = "Recibo de Servicio publico"
                        documentss = valorDocumentss.Pws_Doc_nombre
                    } else if (Number(valorDocumentss.Pws_Doc_Tipo) == 3) {
                        tipo = "Soportes de Ingresos y/o Garantias"
                        documentss = valorDocumentss.Pws_Doc_nombre
                    } else if (Number(valorDocumentss.Pws_Doc_Tipo) == 5) {
                        tipo = "Otros"
                        documentss = valorDocumentss.Pws_Doc_nombre
                    } else if (Number(valorDocumentss.Pws_Doc_Tipo) == 4) {
                        tipo = "Sagrilaft"
                        documentss = valorDocumentss.Pws_Doc_nombre
                        if (Number(user.idProfile) == 1) {
                        } else {
                            pasar = false
                        }
                    }
                    const download = () => {
                        const link = document.createElement('a');
                        link.href = valorDocumentss.Pws_Clave_doc;
                        link.setAttribute(
                            'download',
                            documentss,
                        );
                        link.setAttribute("target", "_blank")
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                    if (pasar) {
                        return (<>
                            <div key={index} className={update ? "redBox" : documentss ? "redBox check" : "redBox"} onClick={(eve: any) => {
                                if (update) {
                                    eve.currentTarget.querySelector('input')?.click()
                                } else {
                                    if (documentss) {
                                        download()
                                    }
                                }
                            }}>
                                {update ? <>
                                    <input
                                        data-id={valorDocumentss.Pws_Doc_Tipo}
                                        type="file"
                                        name="file-input"
                                        id="file-input"
                                        className="file-input__input"
                                        accept="application/pdf, image/png, image/jpg, image/jpeg"
                                        onChange={handleFileInputChange}
                                    />
                                </> : <>
                                </>}
                                {update ? <>
                                    <Documentos /></> : !documentss ? <>
                                        <Documentos /></> : <>
                                    <Documentosred />
                                </>}
                                <p>{tipo}{update ? " (Upload)" : ""}</p>
                            </div>
                        </>)
                    } else {
                        return (<></>)
                    }
                })}
            </div>
        </div>
    );
}
export const Box14 = (dato: any) => {
    const [revisado, setRevisado] = React.useState(true);
    const { user, setUser } = useLoginContext();
    const [hideEstado, sethideEstado] = React.useState(false);
    const [listaEstado, setlistaEstado] = React.useState([] as any);
    const [consulta, setconsulta] = React.useState(true);
    const [detalleSol, setdetalleSol] = React.useState([] as any);
    const [estado, setestado] = React.useState([] as any);
    const [estadocredito, setestadocredito] = React.useState([] as any);
    const [CodigoCredito, setCodigoCredito] = React.useState([] as any);
    const [cupoConsulta, setCupoconsulta] = React.useState('');
    let sagrilaft = dato.dato.infoRetorno.sagrilaft;
    const navigate = useNavigate();

    useEffect(() => {
        setdetalleSol(dato.dato.infoCredito);
        setCupoconsulta(dato.dato.Cupoconsulta);
        console.log('dato que es:', dato.dato.infoCredito)
        if (consulta == true) {
            consultaEstados();
            //setCupoconsulta(Cupoconsulta)
        }
    });

    const cambioEstado = () => {
        sethideEstado(true);
    };
    //Consulta estados
    const consultaEstados = async () => {
        /* const consultaCupo = await WLOCreditAPIService.consultaCupo({
            Pws_Solicitud: detalleSol.Pws_num_solicitud,
            Pws_Identificacion: detalleSol.Pws_Identificacion,
            Pws_num_Tip_Ident: detalleSol.Pws_Tip_Identificacion,
        })
        const cupo = consultaCupo.payload.data.Cupo
        setCupoconsulta(cupo) */

        var i_codigo = '';
        var lista = await AdminService.getListaEstado(i_codigo);
        var list = [{}];
        try {
            setlistaEstado(lista.payload.data.listEstado.Datos_estados);
            const listgadoLineas = lista.payload.data.listEstado.Datos_estados;
            for (let index = 0; index < listgadoLineas.length; index++) {
                if (listgadoLineas[index].s_codigo == dato.dato.infoCredito.Pws_Tip_Estado) {
                    setestadocredito(listgadoLineas[index].s_descripcion);
                    setCodigoCredito(listgadoLineas[index].s_codigo);
                }
            }
            setconsulta(false);
        } catch (error) {
            setlistaEstado(list);
        }
        if (listaEstado == undefined) {
            setlistaEstado(list);
        }
    };

    const closeEstado = () => {
        sethideEstado(false);
    };
    const codigoEstado = async (codigo: any) => {};
    const codigoEstados = async (values: any) => {
        setestado(values.target.value);
    };

    const initialValues = {
        Pws_Tip_Identificacion: '',
        Pws_Identificacion: '',
        Pws_Correo: '',
        Pws_Telefono: '',
    };
    console.log('Valor en Box14:', dato.dato.infoRetorno.score);

    return (
        <div className="box" style={{ display: 'flex', justifyContent: 'left', alignItems: 'left' }}>
            <ul className="title-punto"  style={{ display: 'flex', textAlign: 'center', marginBottom: '10px', position: 'relative'}}>
                <li>4.</li>
                <li>Información de Verificación</li>
                {/* <Person /> */}
            </ul>
            <div className="sub-box">
                <ul>
                    <div className="mapping">
                        <div className="check">
                            {
                                sagrilaft ?
                                <>
                                    <Redx />
                                    <p>Riesgo</p>
                                </>
                                :
                                <>
                                    <GreenCheckBig />
                                    <p>Aprobado</p>
                                </>
                            }
                        
                            {dato.dato.infoRetorno.listaRestrictiva ? (
                                <></>
                            ) : (
                                <>
                                    <h6>Listas restrictivas</h6>
                                </>
                            )}
                            {dato.dato.infoRetorno.sagrilaft ? (
                                <></>
                            ) : (
                                <>
                                    <h6>Sagrilaft</h6>
                                </>
                            )}
                        </div>
                        <div className="score">
                            <Rating valor={dato.dato.infoRetorno.score} />
                        </div>
                    </div>
                </ul>
                <div className="submit">
                    <div className="container">
                        <div className="row">
                            {/* <div className='col-1'>     
                                    <button onClick={()=>{cambioEstado()}}>Cambiar estado</button>
                                    
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="submit">
                    {dato.dato.userPermisos ? (
                        <>
                            {revisado ? (
                                <>
                                    <button
                                        type="button"
                                        style={{ marginTop: '10px' }}
                                        onClick={() => {
                                            setRevisado(false);
                                            dato.dato.changeDatoList(7);
                                        }}>
                                        Revisado
                                    </button>
                                </>
                            ) : (
                                <>
                                    {' '}
                                    <GreenCheck />{' '}
                                </>
                            )}
                        </>
                    ) : (
                        <></>
                    )}
                </div>
                <div className={`${hideEstado}divEstado`}>
                    <div className="sub-box redBox">
                        <div className="container">
                            <div className="row">
                                <div className="col-6 textcenter">
                                    <p>Estados</p>
                                </div>
                                <div className="col-4">
                                    {listaEstado.lenght > 1 ? (
                                        <>
                                            <p>{listaEstado[parseInt(detalleSol.Pws_Tip_Estado) - 1].s_descripcion}</p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                                <div className="col-2">
                                    <button
                                        onClick={() => {
                                            closeEstado();
                                        }}>
                                        close
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-6">
                                    <Formik initialValues={initialValues} onSubmit={codigoEstado}>
                                        {listaEstado.length > 1 ? (
                                            <>
                                                <Field as="select" name={'option'} onBlur={codigoEstados}>
                                                    {listaEstado.map((item: any, key: number) => {
                                                        return (
                                                            <option key={key} id={item.s_codigo} value={item.s_codigo}>
                                                                {item.s_descripcion}
                                                            </option>
                                                        );
                                                    })}
                                                </Field>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </Formik>
                                </div>
                                <div className="col-6">
                                    <button onClick={() => cambioEstado()} className="cambiarEstado">
                                        Cambiar estado
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export const Box9 = (terceros: any) => {
    const [revisado, setRevisado] = React.useState(true)
    const [tercero, agregapro] = React.useState([] as any)
    const [infoPers, setInfoPers] = React.useState([] as any)
    const [revisadoDisable, setRevisadoDisable] = React.useState(true)
    useEffect(() => {
        agregapro(terceros.terceros.valores)
        setInfoPers(terceros.terceros.infoCredito)
        if (terceros.terceros.valores.length == 0) {
            setRevisadoDisable(false)
        } else {
            setRevisadoDisable(true)
        }
    }, [terceros])
    return (
        <div className="box">
            <ul className="title-punto">
                <li>5.</li>
                <li>Consulta a terceros</li>
                <Person />
            </ul>
            <div className="table">
                <ConsultaTercerosTable terceros={{ tercero: tercero, infoPers: infoPers }} />
            </div>
        </div>
    );
}

export const ConsultaTercerosTable = (terceros: any) => {
    const [tercero, agregapro] = React.useState([] as any)
    const [infoPers, setInfoPers] = React.useState([] as any)
    useEffect(() => {
        agregapro(terceros.terceros.tercero)
        setInfoPers(terceros.terceros.infoPers)
    }, [terceros])
    return (
        <div className="referenceTable">
            <div className="table">
                <div className="responsiveFix">
                    <div className="responsiveAuto">
                        <ul>
                            <li className="listItem listHeader">Entidad</li>
                            <li className="listItem listHeader">Puntaje</li>
                            <li className="listItem listHeader">Cuotas Data</li>
                            <li className="listItem listHeader">Riesgo</li>
                            <li className="listItem listHeader">Consultar</li>
                        </ul>
                        {
                            tercero?.map((info: any, i: any) => {
                                return (
                                    <SolicItem key={i} info={info} infoPers={infoPers} />
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

const SolicItem = (info: any) => {
    const [detalleSol, setdetalleSol] = React.useState([] as any);
    useEffect(() => {
        setdetalleSol(info.infoPers)
    })

    const datacredito = async () => {
        const estadoTerce = await AdminService.entidadTer("");
        let puntaje = 0
        let cuotaData = 0
        let consulta
        let estadoDatacredito = "3"
        let sends: WloCreditoService.SolicitudDetalla = {
            Pws_Num_Solicitud: detalleSol.Pws_num_solicitud,
            Pws_Identificacion: detalleSol.Pws_Ideoastntificacion,
            Pws_Tip_Identificacion: detalleSol.Pws_Tip_Identificacion,
            Pws_Perfil_Acceso: "",
            Pws_Fec_Solicitud: "",
        }
        consulta = await WLOCreditAPIService.consultaSolicitudCygnusDetal(sends)
        console.log(consulta.payload.data.datos_persona.Datos_persona[0], "Aqui")
        const data4 = {
            identificacion: detalleSol.Pws_Identificacion,
            primer_apellido: consulta.payload.data.datos_persona.Datos_persona[0].Pws_Apellidos1,
            tipoIdentificacion: String(typeIdentification.WS_TIPOS_IDENTIFICACION_IResult.LstTiposIdent.Datos_TiposIdentificacion.filter(valor => valor.s_codigo == Number(detalleSol.Pws_Tip_Identificacion))[0].s_datacredito)
        }
        const response3 = await WLOCreditAPIService.consultDataCredito2(data4);
        if (response3.payload.success) {
            puntaje = response3.payload.data.Informes.Informe[0].Score[0].$.puntaje
            cuotaData = response3.payload.data.Informes.Informe[0].InfoAgregada[0].Resumen[0].Saldos[0].$.cuotaMensual
            if (puntaje >= 1 && puntaje < 500) {
                estadoDatacredito = "1";
            } else if (puntaje >= 500) {
                estadoDatacredito = "0";
            }
        }
        const data5 = {
            Pws_num_solicitud: String(detalleSol.Pws_num_solicitud),
            Pws_Identificacion: String(detalleSol.Pws_Identificacion!),
            Pws_Tip_Identificacion: String(detalleSol.Pws_Tip_Identificacion!),
            Pws_Fec_gen: String(Moment(new Date()).format('MM/DD/YYYY')),
            Pws_estado_resotp: estadoDatacredito,
            Pws_Tip_val: '2',
            Pws_Puntaje: String(puntaje),
            Pws_Entidad_Consul: '4',
            Pws_Num_cuodat: String(cuotaData * 1000),
        }
        if (estadoTerce.payload.data.ListRef.Datos_Referencias[2].s_descripcion_legal == "1") {
            const response5 = await WLOCreditAPIService.regDataCreditoAndSagrilaft(data5);
            toast.success(response5.payload.data.Pws_R_s_mensaje)
        } else {
            toast.error(response3.payload.data.mensaje)
        }
    }

    const sagrilaft = async () => {
        let sagrilaftRiesgo
        let tipodocumento = '';
        if (detalleSol.Pws_Tip_Identificacion === "12") tipodocumento = "ti"
        if (detalleSol.Pws_Tip_Identificacion === "13") tipodocumento = "cc"
        if (detalleSol.Pws_Tip_Identificacion === "22") tipodocumento = "ce"
        if (detalleSol.Pws_Tip_Identificacion === "31") tipodocumento = "nit"
        if (detalleSol.Pws_Tip_Identificacion === "41") tipodocumento = "pa"

        const data = {
            datoConsultar: detalleSol.Pws_num_solicitud, //19123402
            tipoDocumento: tipodocumento,
            numeroSolicitud: detalleSol.Pws_num_solicitud, //No tenemos un ws que nos diga el nro de solicitud
            fechaSolicitud: Moment(new Date()).format('MM/DD/YYYY'),
            email: '',
        }

        const response = await WLOCreditAPIService.consultaConsolidada(data);
        if (response.payload.presentaRiesgo) {
            sagrilaftRiesgo = "1"
        } else {
            sagrilaftRiesgo = "0"
        }
        //guarda sagrilaft
        const response2 = await WLOCreditAPIService.regDataCreditoAndSagrilaft({
            Pws_num_solicitud: detalleSol.Pws_num_solicitud,
            Pws_Identificacion: detalleSol.Pws_Identificacion,
            Pws_Tip_Identificacion: detalleSol.Pws_Tip_Identificacion,
            Pws_Fec_gen: Moment(new Date()).format('MM/DD/YYYY'),
            Pws_estado_resotp: sagrilaftRiesgo,
            Pws_Tip_val: '1',
            Pws_Puntaje: '0',
            Pws_Entidad_Consul: '2',
            Pws_Num_cuodat: '',
        });
    }

    const consultaScore = async () => {
        let scorepuntaje
        let enestudio
        let scorecygnus
        const response10 = await WLOCreditAPIService.EvaluaScore({
            ps_radicado: String(detalleSol.Pws_num_solicitud),
            ps_identificacion: String(detalleSol.Pws_Identificacion),
            ps_cod_lin: String(detalleSol.Pws_linea_credito),
            ps_tipoCliente: String(detalleSol.Pws_tipo_cliente),
            ps_tip_deucode: "1"
        })
        if (response10.payload.data.estado === "APROBADO") { scorecygnus = true } else {
            enestudio = true
        };
        
        scorepuntaje = response10.payload.data.puntaje_obtenido

        const data6 = {
            Pws_num_solicitud: String(detalleSol.Pws_num_solicitud),
            Pws_Identificacion: String(detalleSol.Pws_Identificacion),
            Pws_Tip_Identificacion: detalleSol.Pws_Tip_Identificacion,
            Pws_Fec_gen: Moment(new Date()).format('MM/DD/YYYY'),
            Pws_estado_resotp: scorecygnus ? "0" : "1",
            Pws_Tip_val: '4',
            Pws_Puntaje: String(scorepuntaje),
            Pws_Entidad_Consul: '5',
            Pws_Num_cuodat: '',
        }
        const response6 = await WLOCreditAPIService.regDataCreditoAndSagrilaft(data6);
    }

    const irpara = (descripcion: string) => {
        if (descripcion == "Score Cygnus") {
            consultaScore();
        }
        if (descripcion == "DataCredito") {
            datacredito();
        }
        if (descripcion == "Sagrilaft") {
            sagrilaft();
        }
    }
    return (
        <>
            <ul>
                <li className="listItem firstItem">{info.info.c_descripcion}</li>
                <li className="listItem">{info.info.puntaje} </li>
                <li className="listItem">{
                    info.info.cuotas_data == "0" ?
                        "-" : <NumberFormat value={info.info.cuotas_data} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                }
                </li>
                <li className="listItem">{info.info.estado_restop == "1" ? "SI" : "NO"}             </li>

                <li className="listItem">
                    {info.info.estado_restop == "3" ?
                        <div onClick={() => { irpara(info.info.c_descripcion) }}><Search /></div> : <div><GreenCheck /></div>
                    }
                </li>
            </ul>
        </>
    )
}

export const DetailCreditRequire = (props: RenderContainerProps) => {
    const { setPopup } = props;
    const { user } = useLoginContext();
    const navigate = useNavigate();
    const buscar = useLocation();
    const [isupdate, setUpdate] = React.useState(true);
    const [persona, DatoPersona] = React.useState({} as any);
    const [dataConyuge, setDataConyuge] = React.useState({} as any);
    const [codigoCodeudor, setCodigoCodeudor] = React.useState({});
    const [alldocuments, setallDocuments] = React.useState([]);
    const { request, setRequest } = useRequestContext();
    const [one] = React.useState({});
    const [arregloValor, valorArreglo] = React.useState([] as any);
    const [arregloValorCodeudor, valorArregloCodeudor] = React.useState([] as any);
    const [radicados, setRadicado] = React.useState({} as any);
    let [isLoading, setIsLoading] = useState(false);
    const [datosReferenciaPersonales, ReferenciaPersonales] = React.useState([]);
    const [datosValorRefer, DatosReferencia] = React.useState({});
    const [listCredit, setListcredit] = useState([]);
    const [infoCredito, setInformacionCredito] = React.useState({} as any);
    const [listadoCon, setListadoCon] = React.useState([] as any);
    const [updatedValues, setUpdatedValues] = useState<any>({});
    const [desembolso, setDesembolso] = React.useState(false);
    const [valorFinanciar, setDataValorFinanciar] = React.useState('');
    const [userPermisos, setuserPermisos] = React.useState(false);
    const [Cupoconsulta, setCupoconsulta] = React.useState('');
    const [datoList, setDatoList] = React.useState(data);
    const [datoListGestor, setDatoListGestor] = React.useState(dataGestor);
    const [dataDesem, datosDesembolso] = React.useState({
        score: 0,
        DataCredito: false,
        listaRestrictiva: false,
        sagrilaft: false,
        estado: 'Simulador',
        color: '1',
    });
    const [riesgo, setRiesto] = React.useState(false);
    const changeDatoList = (id: number) => {
        let valor: {
            bg1: string;
            text: string;
            bg2: string;
            abcilon: string;
            revisado: boolean;
        }[] = [];
        valor = valor.concat(datoListGestor);
        valor[id].abcilon = '';
        valor[id].bg2 = 'none';
        valor[id].bg1 = '#1B9543';
        valor[id].revisado = true;
        setDatoList(valor);
        for (let i = 0; i < 9; i++) {
            // 9 es la ultima sección, antes de la calificacion de solicitud
            if (datoListGestor[i].revisado == false) {
                setDesembolso(false);
                i = 9;
            } else {
                setDesembolso(true);
            }
        }
    };


    useEffect(()=>{
        getValueListCreditos()
        
    },[one])

    const getValueListCreditos =async () =>{
        const valor= await AdminService.getlineascredito();
        if(valor.payload.data.ListLineaCredito.Datos_LineasCredito.length>0){
            setListcredit(valor.payload.data.ListLineaCredito.Datos_LineasCredito)
        }     
    }
    useEffect(() => {
        if (buscar) {
            var valorBusqueda = buscar.search.replace("?", "")
            let arreglo = String(valorBusqueda).split("-")
            valorArreglo(arreglo)
            if (arreglo.length == 3) {
                let codeudors: any = {
                    Pws_codigo: "",
                    Pws_num_solicitud: arreglo[0],
                    Pws_Identificacion: arreglo[1],
                    Pws_Radic_Codeu: arreglo[0],
                    Pws_Tip_Identificacion: arreglo[2],
                    Pws_Iden_Code: "",
                    Pws_Tip_Identificacion_Code: "",
                    Pws_Tip_Codeu: ""
                }
                setRequest({
                    ...request,
                    dataModifcable: {}
                })
                WLOCreditAPIService.addCodeudor(codeudors).then((GetCodeudors) => {
                    if (Number(GetCodeudors.payload.result) > 0) {
                    }
                })
                setCodigoCodeudor(0)
            } else if (arreglo.length > 3) {
                let codeudors: any = {
                    Pws_codigo: "",
                    Pws_num_solicitud: arreglo[0],
                    Pws_Identificacion: arreglo[1],
                    Pws_Radic_Codeu: arreglo[0],
                    Pws_Tip_Identificacion: arreglo[2],
                    Pws_Iden_Code: "",
                    Pws_Tip_Identificacion_Code: "",
                    Pws_Tip_Codeu: ""
                }
                WLOCreditAPIService.addCodeudor(codeudors).then((GetCodeudors) => {
                    if (Number(GetCodeudors.payload.result) > 0) {
                        let paso = false
                        let cedula = ""
                        let type = ""
                        let arregloCodeudor: any = {}
                        GetCodeudors.payload.data.datos_codeu.Datos_codeudor.forEach((element: any) => {
                            if (Number(element.Pws_codigo) == Number(arreglo[3])) {
                                paso = true
                                cedula = element.Pws_Iden_Code
                                type = element.Pws_Tip_Identificacion_Code
                                arregloCodeudor = element
                            }
                        });
                        if (paso) {
                            setUpdate(false)
                            putDatainView(cedula, type, arreglo)
                            valorArregloCodeudor(arregloCodeudor)
                            extraerdatcredRiesgo(arreglo[0], cedula, type)
                            console.log("clg en el use effect")
                        } else {
                            toast.error("No es el codeudor Requerido")
                        }
                    }
                })
                setCodigoCodeudor(arreglo[3])
            }

        }
        document.getElementsByClassName("title")[0].scrollIntoView()
    }, [buscar, navigate])
    const putDatainView = (cedulaSearhc: any, typeCedul: any, arreglo: any) => {
        let sends: WloCreditoService.SolicitudDetalla = {
            Pws_Num_Solicitud: arreglo[0],
            Pws_Identificacion: cedulaSearhc,
            Pws_Tip_Identificacion: typeCedul,
            Pws_Perfil_Acceso: "",
            Pws_Fec_Solicitud: "",
        }
        WLOCreditAPIService.consultaSolicitudCygnusDetal(sends).then((valor) => {
            if (Number(valor.payload.result) > 0) {

                if (valor.payload.data.datos_persona) {
                    if (valor.payload.data.datos_persona.Datos_persona.length > 0) {
                        if (valor.payload.data.datos_operfinan) {
                            if (valor.payload.data.datos_peps) {
                                if (valor.payload.data.datos_peps.Datos_peps.length > 0) {
                                    if (valor.payload.data.datos_operfinan.Datos_operfinan.length > 0) {
                                        let dataCygnus = valor.payload.data.datos_persona.Datos_persona[0]
                                        let dataCygnusOperfin = valor.payload.data.datos_operfinan.Datos_operfinan[0]
                                        let dataCygnusPeps = valor.payload.data.datos_peps.Datos_peps[0]
                                        let dataCygnusCony = valor.payload.data.datos_conyugue?.Datos_conyugue[0];
                                        const datainicial = {
                                            Pws_Identificacion: dataCygnus.Pws_Identificacion,
                                            Pws_Tip_Identificacion: dataCygnus.Pws_Tip_Identificacion,
                                            Pws_Tip_Estado: dataCygnus.Pws_Tip_Estado, // Valor constante para confirmación de información.
                                            Pws_Tip_Perfil: dataCygnus.Pws_Tip_Perfil,
                                            Pws_Tip_person: dataCygnus.Pws_Tip_person,
                                            Pws_Tip_ocupa: dataCygnus.Pws_Tip_ocupa,
                                            Pws_Nombres: dataCygnus.Pws_Nombres,
                                            Pws_Apellidos1: dataCygnus.Pws_Apellidos1,
                                            Pws_Apellidos2: dataCygnus.Pws_Apellidos2,
                                            Pws_Telefono1: dataCygnus.Pws_Telefono1,
                                            Pws_Telefono2: dataCygnus.Pws_Telefono2,
                                            Pws_Correo: dataCygnus.Pws_Correo,
                                            Pws_Fec_expe: dataCygnus.Pws_Fec_expe.split("-00")[0],
                                            Pws_Lugar_exp: dataCygnus.Pws_Lugar_exp,
                                            Pws_Fec_nacime: dataCygnus.Pws_Fec_nacime.split("-00")[0],
                                            Pws_Estado_Civil: dataCygnus.Pws_Estado_Civil,
                                            Pws_Direccion_res: dataCygnus.Pws_Direccion_res,
                                            Pws_Departamento: dataCygnus.Pws_Departamento,
                                            Pws_Ciudad_res: dataCygnus.Pws_Ciudad_res,
                                            Pws_Genero: dataCygnus.Pws_Genero,
                                            Pws_Estrato_per: dataCygnus.Pws_Estrato_per,
                                            Pws_Per_cargo: dataCygnus.Pws_Per_cargo,
                                            Pws_Tip_vivienda: dataCygnus.Pws_Tip_vivienda,
                                            Pws_Niv_estudio: dataCygnus.Pws_Niv_estudio,
                                            Pws_Nom_empre: dataCygnus.Pws_Nom_empre,
                                            Pws_fec_ingemp: dataCygnus.Pws_fec_ingemp.split("-00")[0],
                                            Pws_Fideliza: dataCygnus.Pws_Fideliza,
                                            Pws_Tip_contra: dataCygnus.Pws_Tip_contra,
                                            Pws_Ant_labo: dataCygnus.Pws_Ant_labo,
                                            Pws_Car_emp: dataCygnus.Pws_Car_emp,
                                            Pws_Nom_Jefedi: dataCygnus.Pws_Nom_Jefedi,
                                            Pws_Direc_emp: dataCygnus.Pws_Direc_emp,
                                            Pws_Ciud_emp: dataCygnus.Pws_Ciud_emp,
                                            Pws_tel_emp1: dataCygnus.Pws_tel_emp1,
                                            Pws_tel_emp2: dataCygnus.Pws_tel_emp2,
                                            s_num_solicitud: dataCygnusOperfin.Pws_Num_Solicitud,
                                            s_identificacion: dataCygnus.Pws_Identificacion,
                                            s_tipo_identificacion: dataCygnus.Pws_Tip_Identificacion,
                                            s_ingreso_principal: dataCygnusOperfin.Pws_Ingreso_Principal,
                                            s_otros_ingresos: dataCygnusOperfin.Pws_otros_ingresos,
                                            s_otros_egresos: dataCygnusOperfin.Pws_Otros_egresos,
                                            s_arriendo: dataCygnusOperfin.Pws_Arriendo,
                                            s_concep_otr_ingre: dataCygnusOperfin.Pws_Concep_otr_ingre,
                                            s_declarante_ren: Number(dataCygnusOperfin.Pws_Declarante_ren) == 0 ? false : true,
                                            s_moneda_ext: Number(dataCygnusOperfin.Pws_Moneda_ext) == 0 ? false : true,
                                            s_monext_oper: dataCygnusOperfin.Pws_Monext_oper,
                                            s_tip_monext: dataCygnusOperfin.Pws_Tip_monext,
                                            s_cuent_ext: Number(dataCygnusOperfin.Pws_Cuent_ext) == 0 ? false : true,
                                            s_cuen_extban: dataCygnusOperfin.Pws_Cuen_extban,
                                            s_cuen_extnum: dataCygnusOperfin.Pws_Cuen_extnum,
                                            s_cuen_extpais: dataCygnusOperfin.Pws_Cuen_extpais,
                                            s_cuen_extciudad: dataCygnusOperfin.Pws_Cuen_extciudad,
                                            s_pep_recpublic: Number(dataCygnusPeps.Pws_Pep_recpublic) == 0 ? false : true,
                                            s_pep_poderpublic: Number(dataCygnusPeps.Pws_Pep_poderpublic) == 0 ? false : true,
                                            s_pep_reconpublic: Number(dataCygnusPeps.Pws_Pep_Reconpublic) == 0 ? false : true,
                                            s_pep_pubexpue: Number(dataCygnusPeps.Pws_Pep_pubexpue) == 0 ? false : true,
                                            s_pep_seggraconsa: Number(dataCygnusPeps.Pws_Pep_seggraconsa) == 0 ? false : true,
                                            s_pep_nompepseg: dataCygnusPeps.Pws_Pep_nompepseg,
                                            s_pep_paren: dataCygnusPeps.Pws_Pep_paren,
                                            s_pep_identif: dataCygnusPeps.Pws_Pep_Identif,
                                        }                                        
                                        const dataInicialConyuge = {
                                            Pws_Con_nomsol: dataCygnusCony?.Pws_Con_nomsol,
                                            Pws_Con_Tip_identif: dataCygnusCony?.Pws_Con_Tip_identif,
                                            Pws_Con_identif: dataCygnusCony?.Pws_Con_identif,
                                            Pws_Con_tel:dataCygnusCony?.Pws_Con_tel,
                                        }
                                        buscarDocumentos(arreglo[0], dataCygnus)
                                        DatosReferenciasPersonales(arreglo[0], dataCygnus.Pws_Identificacion, dataCygnus.Pws_Tip_Identificacion);
                                        DatoPersona(datainicial)
                                        setDataConyuge(dataInicialConyuge);
                                        setRequest({
                                            ...request,
                                            dataModifcable: {
                                                identificacion: dataCygnus.Pws_Identificacion,
                                                tipoindentificacion: dataCygnus.Pws_Tip_Identificacion,
                                                codeudorID: arreglo[3],
                                                idUser: dataCygnus.Pws_i_codigo
                                            }
                                        })
                                    }
                                }
                            }

                        }
                    }
                }
            }
        }, (error) => {
            console.log("error")
            console.log(error)
        })

    }

    const onSubmit = async (values: any, formikBag: { setSubmitting: any; }) => {        
        setIsLoading(true);
        if (arregloValor.length > 2) {
            registarDatosreque(arregloValor[0], values, arregloValor[1], arregloValor[2])
        } else {
            toast("No puede Grabar la informacion")
        }

        // /*TEST EBS*/
        // const emailInfo = {
        //     email: String(request.email),
        //     dateSolicitud: new Date().toDateString(),
        //     numsol:String(request.numSol!),
        //     ps_cod_lin:values.pws_cod_credi,
        //     ps_tipoCliente:values.Pws_Tip_ocupa,
        //     radicado: radicados,
        //     Ps_tip_deucode:"1",
        //     rotativo:request.isRotativo
        // }
        // const respuesta   = await WLOCreditAPIService.sendEmailFirmaInicial(emailInfo);

    }


    useEffect(() => {
        const datainicial = {
            Pws_Identificacion: "",
            Pws_Tip_Identificacion: "",
            Pws_Tip_Estado: "2", // Valor constante para confirmación de información.
            Pws_Tip_Perfil: "2",
            Pws_Tip_person: "",
            Pws_Tip_ocupa: "",
            Pws_Nombres: "",
            Pws_Apellidos1: "",
            Pws_Apellidos2: "",
            Pws_Telefono1: "",
            Pws_Telefono2: "",
            Pws_Correo: "",
            Pws_Fec_expe: "",
            Pws_Lugar_exp: "",
            Pws_Fec_nacime: "",
            Pws_Estado_Civil: "",
            Pws_Direccion_res: "",
            Pws_Departamento: "",
            Pws_Ciudad_res: "",
            Pws_Genero: "",
            Pws_Estrato_per: "",
            Pws_Per_cargo: "",
            Pws_Tip_vivienda: "",
            Pws_Niv_estudio: "",
            Pws_Nom_empre: "",
            Pws_fec_ingemp: "",
            Pws_Fideliza: "",
            Pws_Tip_contra: "",
            Pws_Ant_labo: "",
            Pws_Car_emp: "",
            Pws_Nom_Jefedi: "",
            Pws_Direc_emp: "",
            Pws_Ciud_emp: "",
            Pws_tel_emp1: "",
            Pws_tel_emp2: "",
            s_num_solicitud: "",
            s_ref_tipo: '',
            s_ref_parentes: '',
            s_ref_nomcomple: '',
            s_ref_telfij: '',
            s_ref_telcel: '',
            s_identificacion: "",
            s_tipo_identificacion: "",
            s_ingreso_principal: "",
            s_otros_ingresos: "",
            s_otros_egresos: "",
            s_arriendo: "",
            s_concep_otr_ingre: "",
            s_declarante_ren: false,
            s_moneda_ext: false,
            s_monext_oper: "",
            s_tip_monext: "",
            s_cuent_ext: false,
            s_cuen_extban: "",
            s_cuen_extnum: "",
            s_cuen_extpais: "",
            s_cuen_extciudad: "",
            s_pep_recpublic: false,
            s_pep_poderpublic: false,
            s_pep_reconpublic: false,
            s_pep_pubexpue: false,
            s_pep_seggraconsa: false,
            s_pep_nompepseg: "",
            s_pep_paren: "",
            s_pep_identif: "",
        }
        DatoPersona(datainicial)
    }, [one])


    const buscarDocumentos = async (numsol: any, values: any) => {
        const documentRequest = {
            Pws_num_solicitud: numsol!,
            Pws_Identificacion: values.Pws_Identificacion,
            Pws_Tip_Identificacion: values.Pws_Tip_Identificacion,
        };
        const solicitud = await WLOCreditAPIService.ConsultarDocumentos(documentRequest);
        if (solicitud.payload.data.Pws_R_s_cod == "1") {
            if (solicitud.payload.data.datos_doc.datos_Doc) {
                setallDocuments(solicitud.payload.data.datos_doc.datos_Doc)

            } else {
                setallDocuments([])

            }
        }

    }
    const enviarDocumentos = (values: any, numsol: string) => {
        document.getElementsByName("file-input").forEach((element) => {
            var valor = element as HTMLInputElement
            if (valor.files) {
                if (valor.files.length > 0) {
                    var file = valor.files[0];
                    getBase64(file)
                        .then(async result => {
                            const document = result as string;
                            const documentRequest = {
                                Pws_num_solicitud: numsol!,
                                Pws_Identificacion: values.Pws_Identificacion,
                                Pws_Tip_Identificacion: values.Pws_Tip_Identificacion,
                                Pws_Doc_Tipo: valor.dataset.id,
                                Pws_Doc_nombre: file.name,
                                Pws_Doc_estado: "1",
                                Pws_Doc_ruta: "1",
                                Pws_Clave_doc: document,
                            };

                            (async () => {
                                const solicitud = await WLOCreditAPIService.addDocuments(documentRequest);
                                if (Number(solicitud.payload.result) > 0) {
                                    toast.success("Subido el Nuevo Archivo")
                                }

                            })();

                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            }
        });

    }

    const valorCheck = (): Boolean => {
        var letValorAceptado = true
        if (alldocuments.length > 2) {

        } else {
            document.getElementsByName("file-input").forEach((element) => {
                var valor = element as HTMLInputElement
                if (valor.files) {
                    if (valor.files.length > 0) {

                    } else {
                        letValorAceptado = true
                    }
                } else {
                    letValorAceptado = true
                }
            })
        }


        return letValorAceptado
    }
    const valuesFinancieros = async (numsol: string, values: any, pws_identifica: string, pws_tip_identifica: string) => {        

        enviarDocumentos(values, arregloValor[0])
        const operFinancieras = {
            s_num_solicitud: numsol!,
            s_identificacion: values.Pws_Identificacion,
            s_tipo_identificacion: values.Pws_Tip_Identificacion,
            s_ingreso_principal: values.s_ingreso_principal,
            s_otros_ingresos: values.s_otros_ingresos,
            s_otros_egresos: values.s_otros_egresos,
            s_arriendo: values.s_arriendo,
            s_concep_otr_ingre: values.s_concep_otr_ingre,
            s_declarante_ren: (updatedValues.s_moneda_ext ?? values.s_declarante_ren) ? "1" : "0",
            s_moneda_ext: (updatedValues.s_moneda_ext ?? values.s_moneda_ext) ? "1" : "0",
            s_monext_oper: values.s_monext_oper,
            s_tip_monext: values.s_tip_monext,
            s_cuent_ext: (updatedValues.s_cuent_ext ?? values.s_cuent_ext) ? "1" : "0",
            s_cuen_extban:  values.s_cuen_extban,
            s_cuen_extnum:  values.s_cuen_extnum,
            s_cuen_extpais:  values.s_cuen_extpais,
            s_cuen_extciudad: values.s_cuen_extciudad,
        };            
        const result2 = await WLOCreditAPIService.addFinancialInformation(operFinancieras);
        const peps = {
            s_num_solicitud: numsol!,
            s_identificacion: values.Pws_Identificacion,
            s_tipo_identificacion: values.Pws_Tip_Identificacion,
            s_pep_recpublic: (updatedValues.s_pep_recpublic ?? values.s_pep_recpublic) ? "1" : "0",
            s_pep_poderpublic: (updatedValues.s_pep_poderpublic ?? values.s_pep_poderpublic) ? "1" : "0",
            s_pep_reconpublic: (updatedValues.s_pep_reconpublic ?? values.s_pep_reconpublic) ? "1" : "0",
            s_pep_pubexpue: (updatedValues.s_pep_pubexpue ?? values.s_pep_pubexpue) ? "1" : "0",
            s_pep_seggraconsa: (updatedValues.s_pep_seggraconsa ?? values.s_pep_seggraconsa) ? "1" : "0",
            s_pep_nompepseg: values.s_pep_nompepseg,
            s_pep_paren: values.s_pep_paren,
            s_pep_identif: values.s_pep_identif,
        }                        
        const result = await WLOCreditAPIService.addPeps(peps);
        agregarCygnus(numsol, values, pws_identifica, pws_tip_identifica)

    }
    const agregarCygnus = async (numsol: string, values: any, pws_identifica: string, pws_tip_identifica: string) => {
        const cignus = await WLOCreditAPIService.grabar_cignus({
            Pws_Identificacion: values.Pws_Identificacion,
            Pws_Tip_Identificacion: values.Pws_Tip_Identificacion,
            Pws_Tip_Perfil: values.Pws_Tip_Perfil!
        })

        if (Number(cignus.payload.result) > 0) {
            let dataCodeudor = {
                Pws_num_solicitud: numsol,
                Pws_Identificacion: pws_identifica,
                Pws_Radic_Codeu: numsol,
                Pws_Tip_Identificacion: pws_tip_identifica,
                Pws_Iden_Code: values.Pws_Identificacion,
                Pws_Tip_Identificacion_Code: values.Pws_Tip_Identificacion,
                Pws_Tip_NomCodeu: "Requerido",
                Pws_Tip_Codeu: "2",
                Pws_Estado: "1"
            }
            if (Number(codigoCodeudor) > 0) {
                toast.success('Actualizado Correctamente');
                navigate(-1);

            } else {
                SendEmailCodeudor(numsol, values, pws_identifica, pws_tip_identifica)
                /*             const codeudor = await WLOCreditAPIService.addCodeudor(dataCodeudor)
                            console.log(codeudor.payload)
                            if(Number(codeudor.payload.result)>0){
                                console.log(codeudor.payload)
                            }else{
                                toast.error(codeudor.payload.message)
                                
                            }    */
            }

        } else {
            toast.error('Tienes error en el Registro cygnus');
        }
    }
    const SendEmailCodeudor = async (numsol: string, values: any, pws_identifica: string, pws_tip_identifica: string) => {
        let dataCodeudor = {
            Pws_num_solicitud: arregloValor[0],
            Pws_Identificacion: arregloValor[1],
            Pws_Radic_Codeu: arregloValor[0],
            Pws_Tip_Identificacion: arregloValor[2],
            Pws_Iden_Code: values.Pws_Identificacion,
            Pws_Tip_Identificacion_Code: values.Pws_Tip_Identificacion,
            Pws_Tip_Codeu: "2",
            Pws_Estado: "3"
        }
        const valorcodeudor = await WLOCreditAPIService.addCodeudor(dataCodeudor)
        if (Number(valorcodeudor.payload.result) > 0) {
            let valorBusqueda = {} as any
            if (valorcodeudor?.payload?.data?.datos_codeu?.Datos_codeudor) {
                valorcodeudor.payload.data.datos_codeu.Datos_codeudor.forEach((valorcode: any) => {
                    if (valorcode.Pws_Iden_Code == values.Pws_Identificacion && valorcode.Pws_Tip_Identificacion_Code == values.Pws_Tip_Identificacion) {
                        valorBusqueda = valorcode
                        setRadicado(valorcode)
                    }
                })
                if (valorBusqueda.Pws_Iden_Code) {
                    const emailInfo = {
                        email: String(values.Pws_Correo),
                        dateSolicitud: new Date().toDateString(),
                        numsol: String(numsol!),
                        ps_cod_lin: request.valorSolicitud.pws_cod_credi,
                        ps_tipoCliente: values.Pws_Tip_ocupa,
                        radicado: valorBusqueda,
                        Ps_tip_deucode: "2",
                        rotativo: false
                    }
                    const resultEnvioCorreo = await WLOCreditAPIService.sendEmailFirmaInicial(emailInfo);
                    if (user.isSuccessfulLogin) {
                        toast("Se Guardo correctametne el Codeudor Requerido, verifique el correo")
                        navigate(-1)
                    } else {
                        navigate(AppRoutes.CONFIRMATION)
                    }
                    setIsLoading(false)
                    toast("Registrado Correctamente la informacion")
                } else {
                    setIsLoading(false)
                    toast("Tienes error en la consulta del Envio")

                }
            } else {
                toast(valorcodeudor.payload.message)

            }
        } else {
            toast.error(valorcodeudor.payload.message);
            setIsLoading(false)

        }
    }
    const registarDatosreque = async (numsol: string, values: any, pws_identifica: string, pws_tip_identifica: string) => {
        if (valorCheck()) {
            const personaRequest = {
                Pws_Identificacion: values.Pws_Identificacion,
                Pws_Tip_Identificacion: values.Pws_Tip_Identificacion,
                Pws_Tip_Estado: values.Pws_Tip_Estado, // Valor constante para confirmación de información.
                Pws_Tip_Perfil: values.Pws_Tip_Perfil,
                Pws_Tip_person: values.Pws_Tip_person,
                Pws_Tip_ocupa: values.Pws_Tip_ocupa,
                Pws_Nombres: values.Pws_Nombres,
                Pws_Apellidos1: values.Pws_Apellidos1,
                Pws_Apellidos2: values.Pws_Apellidos2,
                Pws_Telefono1: values.Pws_Telefono1,
                Pws_Telefono2: values.Pws_Telefono2,
                Pws_Correo: values.Pws_Correo,
                Pws_Fec_expe: Moment(values.Pws_Fec_expe!).format('MM/DD/YYYY'),
                Pws_Lugar_exp: values.Pws_Lugar_exp,
                Pws_Fec_nacime: Moment(values.Pws_Fec_nacime!).format('MM/DD/YYYY'),
                Pws_Estado_Civil: values.Pws_Estado_Civil,
                Pws_Direccion_res: values.Pws_Direccion_res,
                Pws_Departamento: values.Pws_Departamento,
                Pws_Ciudad_res: values.Pws_Ciudad_res,
                Pws_Genero: values.Pws_Genero,
                Pws_Estrato_per: values.Pws_Estrato_per,
                Pws_Per_cargo: values.Pws_Per_cargo,
                Pws_Tip_vivienda: values.Pws_Tip_vivienda,
                Pws_Niv_estudio: values.Pws_Niv_estudio,
                Pws_Nom_empre: values.Pws_Nom_empre,
                Pws_fec_ingemp: Moment(values.Pws_fec_ingemp!).format('MM/DD/YYYY'),
                Pws_Fideliza: values.Pws_Fideliza,
                Pws_Tip_contra: values.Pws_Tip_contra,
                Pws_Ant_labo: values.Pws_Ant_labo,
                Pws_Car_emp: values.Pws_Car_emp,
                Pws_Nom_Jefedi: values.Pws_Nom_Jefedi,
                Pws_Direc_emp: values.Pws_Direc_emp,
                Pws_Ciud_emp: values.Pws_Ciud_emp,
                Pws_tel_emp1: values.Pws_tel_emp1,
                Pws_tel_emp2: values.Pws_tel_emp2,
            }
            const resultUpdatePersona = await WLOCreditAPIService.addSolicitudPersona(personaRequest)            
            if (Number(resultUpdatePersona.payload.result) > 0 || Number(resultUpdatePersona.payload.result) == -4) {
                if (Number(resultUpdatePersona.payload.result) == -4) {
                    const resultConsultaPersona = await WLOCreditAPIService.consultaSolicitudCygnus({
                        Pws_Identificacion: values.Pws_Identificacion,
                        Pws_Tip_Identificacion: values.Pws_Tip_Identificacion
                    });
                    if (!_.isEmpty(resultConsultaPersona.payload) && resultConsultaPersona.payload.result > 0) {
                        const personaConsultaResult = resultConsultaPersona.payload.data.datos_persona.Datos_persona[0];
                        const infoUpdatePerson = { ...personaRequest, Pws_i_codigo: personaConsultaResult ? personaConsultaResult.Pws_i_codigo : 0 };
                        const resultUpdatePersona2 = await WLOCreditAPIService.addSolicitudPersona(infoUpdatePerson);
                        if (resultUpdatePersona2.payload.result > 0) {
                            valuesFinancieros(numsol, values, pws_identifica, pws_tip_identifica)
                            setIsLoading(false)
                        } else {
                            setIsLoading(false)
                            toast.error(resultUpdatePersona2.payload.message);
                        }
                    }
                } else {
                    setIsLoading(false)
                    valuesFinancieros(numsol, values, pws_identifica, pws_tip_identifica)
                }
            } else {
                setIsLoading(false)
                toast.error(resultUpdatePersona.payload.MensajeError);

            }
        } else {
            toast.error("Debes completar los Documentos Necesarios")
        }

    }

    const getBase64 = (file: any) => {
        return new Promise(resolve => {
            let baseURL: string | ArrayBuffer | null = "";
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    }

    const DatosReferenciasPersonales = (solicitud: string, identificacion: string, tipo_identificacion: string) => {
        WLOCreditAPIService.addReferences({
            s_num_solicitud: solicitud!,
            s_identificacion: identificacion!,
            s_tipo_identificacion: tipo_identificacion!,
            s_ref_tipo: "",
            s_ref_parentes: "",
            s_ref_nomcomple: "",
            s_ref_telfij: "",
            s_ref_telcel: ""
        }).then((ValorReferencias) => {
            if (Number(ValorReferencias.payload.result) > 0) {
                ReferenciaPersonales(ValorReferencias.payload.data.datos_referencia.datos_refer)
            }
            DatosReferencia({
                s_num_solicitud: solicitud!,
                s_identificacion: identificacion!,
                s_tipo_identificacion: tipo_identificacion!,
                s_ref_tipo: "",
                s_ref_parentes: "",
                s_ref_nomcomple: "",
                s_ref_telfij: "",
                s_ref_telcel: ""
            })
        })
    }
    const updateValorFinancie = (field: string, value: any) => {
        // Lógica para actualizar valorFinancie        
        console.log(field);
        console.log(value);
        setUpdatedValues((prevValues: any) => ({
            ...prevValues,
            [field]: value,
        }));

        
      };
    const forwardingFirma = async () => {
        const result = await WLOCreditAPIService.addSolicitud({
            
            Pws_num_solicitud:arregloValor[0],
            Pws_Identificacion: arregloValor[1],
            Pws_Tip_Identificacion: arregloValor[2],    
        })

        setInformacionCredito(result.payload.data.Datos_Sol.Datos_Sol[0])
        let rotativo = false
        const lista = listCredit.filter((valor: any) =>
            valor.s_codigo == Number(infoCredito.Pws_linea_credito)).length > 0 ? listCredit.filter(
                (valor: any) => valor.s_codigo == infoCredito.Pws_linea_credito)[0]['s_rotativo'] : "0"
        if (Number(lista) == 1) {
            rotativo = true
        }
        const emailInfo = {
            email: persona.Pws_Correo,
            dateSolicitud: new Date().toDateString(),
            numsol: arregloValor[0],
            ps_cod_lin: infoCredito.Pws_linea_credito,
            ps_tipoCliente: persona.Pws_Tip_ocupa,
            radicado: arregloValorCodeudor,
            Ps_tip_deucode: "2",
            rotativo: rotativo
        }
        setIsLoading(true);
        const resultEnvioCorreo = await WLOCreditAPIService.sendEmailFirmaInicial(emailInfo);
        if (resultEnvioCorreo.response.substr(0, 12) == "250 2.0.0 Ok") {
            setIsLoading(false);
            toast.success("Firma enviada correctamente")
        } else {
            toast.error("Se presento un error al momento de enviar la firma, intente nuevamente")
        }
    }

    const extraerdatcredRiesgo = async (valor: string, valor2: string, valor3: string) => {
        const result = await WLOCreditAPIService.regDataCreditoAndSagrilaft({
            Pws_num_solicitud: valor,
            Pws_Identificacion: valor2,
            Pws_Tip_Identificacion: valor3,//Valor que pide el como  ws pero a nivel de UI no existe
        })
        var i_codigo = ""
        const entidadter = await AdminService.entidadTer(i_codigo);
        if (result.payload) {
            if (result.payload.data) {
                if (result.payload.data.datos_datacre) {
                    if (result.payload.data.datos_datacre.datos_datacredito) {
                        var listado = new Array()
                        var listDataCredito = result.payload.data.datos_datacre.datos_datacredito
                        for (let index = 0; index < listDataCredito.length; index++) {
                            let listadoConsultas = {
                                estado_restop: String,
                                tipo_valida: String,
                                c_descripcion: String,
                                puntaje: String,
                                cuotas_data: String
                            }

                            listadoConsultas.estado_restop = listDataCredito[index].Pws_estado_resotp
                            listadoConsultas.tipo_valida = listDataCredito[index].Pws_Tip_val
                            listadoConsultas.c_descripcion = entidadter.payload.data.ListRef.Datos_Referencias[parseInt(listDataCredito[index].Pws_Entidad_Consul) - 1].s_descripcion
                            listadoConsultas.puntaje = listDataCredito[index].Pws_Puntaje
                            listadoConsultas.cuotas_data = listDataCredito[index].n_Pws_Num_cuodat
                            listado[index] = listadoConsultas

                            if (Number(listDataCredito[index].Pws_Entidad_Consul) == 5) {
                                if (Number(listDataCredito[index].Pws_estado_resotp) == 1) {
                                    setRiesto(true);
                                }
                                dataDesem.score = Number(listDataCredito[index].Pws_Puntaje);
                            }
                        }

                        setListadoCon(listado)

                    }
                }
            }
        }
    }

    return (
        <div className="detailCreditR" >
            <ClockLoader id='spinner' color={"#d72222"} loading={isLoading} size={100} />
            <div className="header">
                <Fab variant="extended" color="neutral" aria-label="add"
                    onClick={() => {
                        navigate(-1)
                    }}
                    style={{ float: "left" }} className="hooverButtonRed">
                    <ArrowBack sx={{ mr: 1 }} className="hooverButtonRedsvg" />
                    {"Atras"}
                </Fab>
                <h2 className="title">Detalle del codeudor requerido</h2>
                
                    
                {!isupdate ? <>
                    {/* <div onClick={() => envioFirma()}>
                    <NoteAltTwoTone
                        fontSize='large'
                        htmlColor='#D0021B'
                        titleAccess='Enviar Firma' />
                    </div> */}
                    <ul className="submit">  
                        <button onClick={()=>forwardingFirma()}>Enviar firma</button>
                    </ul>
                </> : <>
                    <Fab variant="extended" color="error" aria-label="add" onClick={() => {
                        document.getElementById("saveutton")?.click()
                    }} className="hooverButtonsubmit">
                        {'Agregar'}
                        <ArrowForward className="hooverButtonRedsvgsubmit buttonAgregarCoRe" sx={{ mr: 1 }} />
                    </Fab>
                </>}
            </div>
            <div className="mainDetail">
                <Formik
                    enableReinitialize={true}
                    initialValues={persona}
                    onSubmit={onSubmit}
                >
                    {({ isSubmitting, values, errors }) => (
                        <>
                            <Form>
                                <Box2 valorPersonal={{ dataConyuge: dataConyuge, person: values, update: isupdate, setPopup, arreglo: arregloValor, setUpdate, errors }} />
                                <Box3 valorFinancie={{ valorinic: values, datopeps: values, update: isupdate }} updateValorFinancie={updateValorFinancie} />    
                                <Box5 valorReferencias={{ datosrefe: datosReferenciaPersonales, values: datosValorRefer, arreglo: arregloValor, person: values, putDatainView }} />
                                {isupdate ? <>
                                    
                                </> : <>
                                
                                <Box14
                                    dato={{
                                        setDesembolso,
                                        infoRetorno: dataDesem,
                                        changeDatoList,
                                        valorAFinanciar: valorFinanciar,
                                        infoCredito,
                                        infodeSolicitud: infoCredito,
                                        Cupoconsulta,
                                        userPermisos,
                                    }}
                                />
                                </>
                                }
                               <Box9 terceros={{ valores: listadoCon, arreglos: arregloValor, infoCredito }} />

                                <Box8 valorFinancie={{ valorinic: values, update: isupdate, datosdocuments: alldocuments, arreglo: arregloValor }} />
                                <button type="submit" style={{ display: "none" }} id="saveutton"></button>
                            </Form>
                        </>)}

                </Formik>
            </div>
        </div>
    )
}
